// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /* @import url(cstheme.css);  */

  /* @tailwind base;*/
  .container {
    width: 100%;
}
  @media (min-width: 640px) {
    .container {
        max-width: 640px;
    }
}
  @media (min-width: 768px) {
    .container {
        max-width: 768px;
    }
}
  @media (min-width: 1024px) {
    .container {
        max-width: 1024px;
    }
}
  @media (min-width: 1280px) {
    .container {
        max-width: 1280px;
    }
}
  @media (min-width: 1536px) {
    .container {
        max-width: 1536px;
    }
}
  .sidebar-link-text {
    color: var(--sidebar-font-color);
  }
  .pointer-events-none {
    pointer-events: none;
}
  .\\!visible {
    visibility: visible !important;
}
  .visible {
    visibility: visible;
}
  .collapse {
    visibility: collapse;
}
  .static {
    position: static;
}
  .fixed {
    position: fixed;
}
  .absolute {
    position: absolute;
}
  .relative {
    position: relative;
}
  .sticky {
    position: sticky;
}
  .inset-0 {
    inset: 0px;
}
  .-right-1 {
    right: -0.25rem;
}
  .-top-1 {
    top: -0.25rem;
}
  .left-0 {
    left: 0px;
}
  .left-1\\/2 {
    left: 50%;
}
  .left-3 {
    left: 0.75rem;
}
  .left-\\[-100\\%\\] {
    left: -100%;
}
  .left-\\[-10px\\] {
    left: -10px;
}
  .right-0 {
    right: 0px;
}
  .right-2 {
    right: 0.5rem;
}
  .right-4 {
    right: 1rem;
}
  .right-5 {
    right: 1.25rem;
}
  .right-\\[13px\\] {
    right: 13px;
}
  .right-\\[8px\\] {
    right: 8px;
}
  .top-0 {
    top: 0px;
}
  .top-1\\/2 {
    top: 50%;
}
  .top-12 {
    top: 3rem;
}
  .top-2 {
    top: 0.5rem;
}
  .top-4 {
    top: 1rem;
}
  .top-5 {
    top: 1.25rem;
}
  .top-\\[13px\\] {
    top: 13px;
}
  .top-\\[37px\\] {
    top: 37px;
}
  .top-full {
    top: 100%;
}
  .z-0 {
    z-index: 0;
}
  .z-10 {
    z-index: 10;
}
  .z-50 {
    z-index: 50;
}
  .z-\\[1000\\] {
    z-index: 1000;
}
  .z-\\[1\\] {
    z-index: 1;
}
  .z-\\[2\\] {
    z-index: 2;
}
  .col-span-1 {
    grid-column: span 1 / span 1;
}
  .col-span-2 {
    grid-column: span 2 / span 2;
}
  .m-0 {
    margin: 0px;
}
  .m-2 {
    margin: 0.5rem;
}
  .mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
}
  .mx-1\\.5 {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
}
  .mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
}
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
}
  .my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
}
  .my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
  .my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}
  .my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
}
  .my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}
  .mb-0 {
    margin-bottom: 0px;
}
  .mb-1 {
    margin-bottom: 0.25rem;
}
  .mb-2 {
    margin-bottom: 0.5rem;
}
  .mb-3 {
    margin-bottom: 0.75rem;
}
  .mb-4 {
    margin-bottom: 1rem;
}
  .mb-5 {
    margin-bottom: 1.25rem;
}
  .mb-6 {
    margin-bottom: 1.5rem;
}
  .mb-7 {
    margin-bottom: 1.75rem;
}
  .mb-8 {
    margin-bottom: 2rem;
}
  .mb-9 {
    margin-bottom: 2.25rem;
}
  .mb-\\[10px\\] {
    margin-bottom: 10px;
}
  .mb-\\[16px\\] {
    margin-bottom: 16px;
}
  .mb-\\[18px\\] {
    margin-bottom: 18px;
}
  .ml-1 {
    margin-left: 0.25rem;
}
  .ml-1\\.5 {
    margin-left: 0.375rem;
}
  .ml-2 {
    margin-left: 0.5rem;
}
  .ml-3 {
    margin-left: 0.75rem;
}
  .ml-4 {
    margin-left: 1rem;
}
  .ml-6 {
    margin-left: 1.5rem;
}
  .ml-auto {
    margin-left: auto;
}
  .mr-0 {
    margin-right: 0px;
}
  .mr-1 {
    margin-right: 0.25rem;
}
  .mr-2 {
    margin-right: 0.5rem;
}
  .mr-3 {
    margin-right: 0.75rem;
}
  .mr-4 {
    margin-right: 1rem;
}
  .mr-\\[18px\\] {
    margin-right: 18px;
}
  .mt-0 {
    margin-top: 0px;
}
  .mt-0\\.5 {
    margin-top: 0.125rem;
}
  .mt-1 {
    margin-top: 0.25rem;
}
  .mt-2 {
    margin-top: 0.5rem;
}
  .mt-3 {
    margin-top: 0.75rem;
}
  .mt-4 {
    margin-top: 1rem;
}
  .mt-5 {
    margin-top: 1.25rem;
}
  .mt-6 {
    margin-top: 1.5rem;
}
  .mt-8 {
    margin-top: 2rem;
}
  .mt-\\[0px\\] {
    margin-top: 0px;
}
  .mt-\\[6px\\] {
    margin-top: 6px;
}
  .mt-auto {
    margin-top: auto;
}
  .block {
    display: block;
}
  .inline-block {
    display: inline-block;
}
  .inline {
    display: inline;
}
  .flex {
    display: flex;
}
  .inline-flex {
    display: inline-flex;
}
  .table {
    display: table;
}
  .grid {
    display: grid;
}
  .hidden {
    display: none;
}
  .h-0 {
    height: 0px;
}
  .h-10 {
    height: 2.5rem;
}
  .h-11 {
    height: 2.75rem;
}
  .h-12 {
    height: 3rem;
}
  .h-16 {
    height: 4rem;
}
  .h-2 {
    height: 0.5rem;
}
  .h-24 {
    height: 6rem;
}
  .h-28 {
    height: 7rem;
}
  .h-3 {
    height: 0.75rem;
}
  .h-32 {
    height: 8rem;
}
  .h-4 {
    height: 1rem;
}
  .h-48 {
    height: 12rem;
}
  .h-5 {
    height: 1.25rem;
}
  .h-6 {
    height: 1.5rem;
}
  .h-64 {
    height: 16rem;
}
  .h-8 {
    height: 2rem;
}
  .h-96 {
    height: 24rem;
}
  .h-\\[100px\\] {
    height: 100px;
}
  .h-\\[2px\\] {
    height: 2px;
}
  .h-\\[30px\\] {
    height: 30px;
}
  .h-\\[38px\\] {
    height: 38px;
}
  .h-\\[40px\\] {
    height: 40px;
}
  .h-\\[45px\\] {
    height: 45px;
}
  .h-\\[60px\\] {
    height: 60px;
}
  .h-\\[85vh\\] {
    height: 85vh;
}
  .h-auto {
    height: auto;
}
  .h-full {
    height: 100%;
}
  .h-screen {
    height: 100vh;
}
  .max-h-24 {
    max-height: 6rem;
}
  .min-h-0 {
    min-height: 0px;
}
  .min-h-\\[200px\\] {
    min-height: 200px;
}
  .min-h-\\[650px\\] {
    min-height: 650px;
}
  .min-h-full {
    min-height: 100%;
}
  .min-h-screen {
    min-height: 100vh;
}
  .w-0 {
    width: 0px;
}
  .w-1\\/2 {
    width: 50%;
}
  .w-10 {
    width: 2.5rem;
}
  .w-12 {
    width: 3rem;
}
  .w-16 {
    width: 4rem;
}
  .w-2 {
    width: 0.5rem;
}
  .w-2\\.5 {
    width: 0.625rem;
}
  .w-24 {
    width: 6rem;
}
  .w-3 {
    width: 0.75rem;
}
  .w-3\\/4 {
    width: 75%;
}
  .w-32 {
    width: 8rem;
}
  .w-4 {
    width: 1rem;
}
  .w-48 {
    width: 12rem;
}
  .w-5 {
    width: 1.25rem;
}
  .w-56 {
    width: 14rem;
}
  .w-6 {
    width: 1.5rem;
}
  .w-64 {
    width: 16rem;
}
  .w-8 {
    width: 2rem;
}
  .w-96 {
    width: 24rem;
}
  .w-\\[100px\\] {
    width: 100px;
}
  .w-\\[135px\\] {
    width: 135px;
}
  .w-\\[250px\\] {
    width: 250px;
}
  .w-\\[300px\\] {
    width: 300px;
}
  .w-\\[30px\\] {
    width: 30px;
}
  .w-\\[60px\\] {
    width: 60px;
}
  .w-\\[90\\%\\] {
    width: 90%;
}
  .w-\\[90px\\] {
    width: 90px;
}
  .w-full {
    width: 100%;
}
  .min-w-\\[100px\\] {
    min-width: 100px;
}
  .min-w-full {
    min-width: 100%;
}
  .max-w-3xl {
    max-width: 48rem;
}
  .max-w-4xl {
    max-width: 56rem;
}
  .max-w-6xl {
    max-width: 72rem;
}
  .max-w-\\[1100px\\] {
    max-width: 1100px;
}
  .max-w-\\[1180px\\] {
    max-width: 1180px;
}
  .max-w-\\[320px\\] {
    max-width: 320px;
}
  .max-w-\\[350px\\] {
    max-width: 350px;
}
  .max-w-\\[450px\\] {
    max-width: 450px;
}
  .max-w-\\[90\\%\\] {
    max-width: 90%;
}
  .max-w-full {
    max-width: 100%;
}
  .max-w-md {
    max-width: 28rem;
}
  .max-w-xs {
    max-width: 20rem;
}
  .flex-1 {
    flex: 1 1;
}
  .flex-\\[1\\.2\\] {
    flex: 1.2 1;
}
  .shrink-0 {
    flex-shrink: 0;
}
  .flex-grow {
    flex-grow: 1;
}
  .origin-top-left {
    transform-origin: top left;
}
  .-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .-translate-y-full {
    --tw-translate-y: -100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .rotate-45 {
    --tw-rotate: 45deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .scale-50 {
    --tw-scale-x: .5;
    --tw-scale-y: .5;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .scale-90 {
    --tw-scale-x: .9;
    --tw-scale-y: .9;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .animate-\\[containerFadeIn_0\\.8s_ease-out\\] {
    animation: containerFadeIn 0.8s ease-out;
}
  .animate-\\[slideInRight_0\\.8s_ease-out_1s_both\\] {
    animation: slideInRight 0.8s ease-out 1s both;
}
  @keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
  .animate-spin {
    animation: spin 1s linear infinite;
}
  .cursor-not-allowed {
    cursor: not-allowed;
}
  .cursor-pointer {
    cursor: pointer;
}
  .select-none {
    -webkit-user-select: none;
            user-select: none;
}
  .resize {
    resize: both;
}
  .list-disc {
    list-style-type: disc;
}
  .list-none {
    list-style-type: none;
}
  .appearance-none {
    appearance: none;
}
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
  .flex-col {
    flex-direction: column;
}
  .flex-wrap {
    flex-wrap: wrap;
}
  .items-start {
    align-items: flex-start;
}
  .items-end {
    align-items: flex-end;
}
  .items-center {
    align-items: center;
}
  .justify-start {
    justify-content: flex-start;
}
  .justify-end {
    justify-content: flex-end;
}
  .justify-center {
    justify-content: center;
}
  .justify-between {
    justify-content: space-between;
}
  .gap-1 {
    gap: 0.25rem;
}
  .gap-2 {
    gap: 0.5rem;
}
  .gap-2\\.5 {
    gap: 0.625rem;
}
  .gap-3 {
    gap: 0.75rem;
}
  .gap-4 {
    gap: 1rem;
}
  .gap-6 {
    gap: 1.5rem;
}
  .gap-\\[18px\\] {
    gap: 18px;
}
  .space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
  .space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
  .space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
  .space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
  .space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
  .space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
  .space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
  .space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
  .space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
  .divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
  .divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
  .overflow-auto {
    overflow: auto;
}
  .overflow-hidden {
    overflow: hidden;
}
  .overflow-x-auto {
    overflow-x: auto;
}
  .overflow-y-auto {
    overflow-y: auto;
}
  .overflow-x-hidden {
    overflow-x: hidden;
}
  .whitespace-normal {
    white-space: normal;
}
  .whitespace-nowrap {
    white-space: nowrap;
}
  .whitespace-pre-line {
    white-space: pre-line;
}
  .break-words {
    overflow-wrap: break-word;
}
  .rounded {
    border-radius: 0.25rem;
}
  .rounded-2xl {
    border-radius: 1rem;
}
  .rounded-3xl {
    border-radius: 1.5rem;
}
  .rounded-full {
    border-radius: 9999px;
}
  .rounded-lg {
    border-radius: 12px;
}
  .rounded-md {
    border-radius: 8px;
}
  .rounded-sm {
    border-radius: 6px;
}
  .rounded-xl {
    border-radius: 0.75rem;
}
  .rounded-l-sm {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}
  .rounded-r-md {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}
  .rounded-r-none {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}
  .rounded-r-sm {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
}
  .rounded-t-lg {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}
  .rounded-bl-none {
    border-bottom-left-radius: 0px;
}
  .rounded-br-none {
    border-bottom-right-radius: 0px;
}
  .border {
    border-width: 1px;
}
  .border-0 {
    border-width: 0px;
}
  .border-2 {
    border-width: 2px;
}
  .border-4 {
    border-width: 4px;
}
  .border-x-0 {
    border-left-width: 0px;
    border-right-width: 0px;
}
  .border-b {
    border-bottom-width: 1px;
}
  .border-b-0 {
    border-bottom-width: 0px;
}
  .border-b-2 {
    border-bottom-width: 2px;
}
  .border-l {
    border-left-width: 1px;
}
  .border-l-0 {
    border-left-width: 0px;
}
  .border-l-4 {
    border-left-width: 4px;
}
  .border-r-0 {
    border-right-width: 0px;
}
  .border-r-4 {
    border-right-width: 4px;
}
  .border-t {
    border-top-width: 1px;
}
  .border-t-0 {
    border-top-width: 0px;
}
  .border-solid {
    border-style: solid;
}
  .border-dashed {
    border-style: dashed;
}
  .border-none {
    border-style: none;
}
  .\\!border-red-500 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(239 68 68 / var(--tw-border-opacity)) !important;
}
  .border-\\[\\#e74c3c\\] {
    --tw-border-opacity: 1;
    border-color: rgb(231 76 60 / var(--tw-border-opacity));
}
  .border-\\[\\#f5f2ec\\] {
    --tw-border-opacity: 1;
    border-color: rgb(245 242 236 / var(--tw-border-opacity));
}
  .border-amber-200 {
    --tw-border-opacity: 1;
    border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
  .border-blue-200 {
    --tw-border-opacity: 1;
    border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
  .border-blue-300 {
    --tw-border-opacity: 1;
    border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
  .border-blue-500 {
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
  .border-blue-600 {
    --tw-border-opacity: 1;
    border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
  .border-gray-100 {
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
  .border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
  .border-gray-300 {
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
  .border-gray-400 {
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
  .border-gray-light {
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
  .border-gray-medium {
    --tw-border-opacity: 1;
    border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
  .border-green-300 {
    --tw-border-opacity: 1;
    border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
  .border-green-500 {
    --tw-border-opacity: 1;
    border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
  .border-orange-300 {
    --tw-border-opacity: 1;
    border-color: rgb(253 186 116 / var(--tw-border-opacity));
}
  .border-red-200 {
    --tw-border-opacity: 1;
    border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
  .border-red-400 {
    --tw-border-opacity: 1;
    border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
  .border-red-500 {
    --tw-border-opacity: 1;
    border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
  .border-slate-300 {
    --tw-border-opacity: 1;
    border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
  .border-transparent {
    border-color: transparent;
}
  .border-violet-300 {
    --tw-border-opacity: 1;
    border-color: rgb(196 181 253 / var(--tw-border-opacity));
}
  .border-white {
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
  .border-white\\/20 {
    border-color: rgb(255 255 255 / 0.2);
}
  .border-white\\/30 {
    border-color: rgb(255 255 255 / 0.3);
}
  .border-t-slate-600 {
    --tw-border-opacity: 1;
    border-top-color: rgb(71 85 105 / var(--tw-border-opacity));
}
  .border-t-white {
    --tw-border-opacity: 1;
    border-top-color: rgb(255 255 255 / var(--tw-border-opacity));
}
  .border-opacity-30 {
    --tw-border-opacity: 0.3;
}
  .border-opacity-5 {
    --tw-border-opacity: 0.05;
}
  .\\!bg-red-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity)) !important;
}
  .bg-\\[\\#f5f2ec\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(245 242 236 / var(--tw-bg-opacity));
}
  .bg-\\[\\#f9fafb\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
  .bg-\\[\\#faf8f4\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(250 248 244 / var(--tw-bg-opacity));
}
  .bg-\\[\\#fdf2f2\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(253 242 242 / var(--tw-bg-opacity));
}
  .bg-amber-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(253 230 138 / var(--tw-bg-opacity));
}
  .bg-amber-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
  .bg-amber-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
  .bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
  .bg-blue-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
  .bg-blue-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
  .bg-blue-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
  .bg-blue-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
  .bg-blue-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
  .bg-emerald-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
  .bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
  .bg-gray-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
  .bg-gray-400 {
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
  .bg-gray-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
  .bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
  .bg-green-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
  .bg-green-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
  .bg-green-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
  .bg-green-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
  .bg-indigo-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
  .bg-indigo-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
  .bg-indigo-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
  .bg-orange-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
  .bg-orange-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
  .bg-primary {
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
  .bg-purple-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
  .bg-red-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
  .bg-red-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}
  .bg-red-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
  .bg-red-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
  .bg-red-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
  .bg-sky-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
  .bg-slate-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
  .bg-teal-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(153 246 228 / var(--tw-bg-opacity));
}
  .bg-teal-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(13 148 136 / var(--tw-bg-opacity));
}
  .bg-transparent {
    background-color: transparent;
}
  .bg-violet-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(237 233 254 / var(--tw-bg-opacity));
}
  .bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
  .bg-yellow-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(254 240 138 / var(--tw-bg-opacity));
}
  .bg-opacity-20 {
    --tw-bg-opacity: 0.2;
}
  .bg-opacity-30 {
    --tw-bg-opacity: 0.3;
}
  .bg-opacity-50 {
    --tw-bg-opacity: 0.5;
}
  .bg-\\[radial-gradient\\(circle\\2c \\#6B7C93_0\\%\\2c transparent_70\\%\\)\\] {
    background-image: radial-gradient(circle,#6B7C93 0%,transparent 70%);
}
  .bg-\\[radial-gradient\\(circle\\2c var\\(--primaryColor\\)_0\\%\\2c transparent_70\\%\\)\\] {
    background-image: radial-gradient(circle,var(--primaryColor) 0%,transparent 70%);
}
  .bg-\\[radial-gradient\\(circle_at_20\\%_80\\%\\2c rgba\\(220\\2c 197\\2c 146\\2c 0\\.2\\)_0\\%\\2c transparent_50\\%\\)\\2c radial-gradient\\(circle_at_80\\%_20\\%\\2c rgba\\(201\\2c 168\\2c 118\\2c 0\\.2\\)_0\\%\\2c transparent_50\\%\\)\\2c radial-gradient\\(circle_at_40\\%_40\\%\\2c rgba\\(184\\2c 149\\2c 106\\2c 0\\.1\\)_0\\%\\2c transparent_50\\%\\)\\] {
    background-image: radial-gradient(circle at 20% 80%,rgba(220,197,146,0.2) 0%,transparent 50%),radial-gradient(circle at 80% 20%,rgba(201,168,118,0.2) 0%,transparent 50%),radial-gradient(circle at 40% 40%,rgba(184,149,106,0.1) 0%,transparent 50%);
}
  .bg-\\[radial-gradient\\(circle_at_20\\%_80\\%\\2c var\\(--boxShadow\\)_0\\%\\2c transparent_50\\%\\)\\2c radial-gradient\\(circle_at_80\\%_20\\%\\2c var\\(--boxShadow\\)_0\\%\\2c transparent_50\\%\\)\\2c radial-gradient\\(circle_at_40\\%_40\\%\\2c var\\(--boxShadow\\)_0\\%\\2c transparent_50\\%\\)\\] {
    background-image: radial-gradient(circle at 20% 80%,var(--boxShadow) 0%,transparent 50%),radial-gradient(circle at 80% 20%,var(--boxShadow) 0%,transparent 50%),radial-gradient(circle at 40% 40%,var(--boxShadow) 0%,transparent 50%);
}
  .bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
  .bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
  .bg-none {
    background-image: none;
}
  .from-\\[\\#6B7C93\\] {
    --tw-gradient-from: #6B7C93 var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(107 124 147 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-\\[var\\(--boxShadow\\)\\] {
    --tw-gradient-from: var(--boxShadow) var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-\\[var\\(--charcoal\\)\\] {
    --tw-gradient-from: var(--charcoal) var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-\\[var\\(--primaryColor\\)\\] {
    --tw-gradient-from: var(--primaryColor) var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-slate-400 {
    --tw-gradient-from: #94a3b8 var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(148 163 184 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-slate-600 {
    --tw-gradient-from: #475569 var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(71 85 105 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-slate-700 {
    --tw-gradient-from: #334155 var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(51 65 85 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-transparent {
    --tw-gradient-from: transparent var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-white {
    --tw-gradient-from: #fff var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .from-white\\/25 {
    --tw-gradient-from: rgb(255 255 255 / 0.25) var(--tw-gradient-from-position);
    --tw-gradient-from-position:  ;
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-from-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
  .via-\\[\\#f5f2ec\\] {
    --tw-gradient-via-position:  ;
    --tw-gradient-to: rgb(245 242 236 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), #f5f2ec var(--tw-gradient-via-position), var(--tw-gradient-to);
}
  .via-slate-50 {
    --tw-gradient-via-position:  ;
    --tw-gradient-to: rgb(248 250 252 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), #f8fafc var(--tw-gradient-via-position), var(--tw-gradient-to);
}
  .via-slate-500 {
    --tw-gradient-via-position:  ;
    --tw-gradient-to: rgb(100 116 139 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), #64748b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
  .via-slate-600 {
    --tw-gradient-via-position:  ;
    --tw-gradient-to: rgb(71 85 105 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), #475569 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
  .via-white {
    --tw-gradient-via-position:  ;
    --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
    --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
  .to-\\[\\#2C3E50\\] {
    --tw-gradient-to: #2C3E50 var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.75\\)\\] {
    --tw-gradient-to: rgba(255,255,255,0.75) var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-\\[var\\(--boxShadow\\)\\] {
    --tw-gradient-to: var(--boxShadow) var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-\\[var\\(--charcoal\\)\\] {
    --tw-gradient-to: var(--charcoal) var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-\\[var\\(--primaryColor\\)\\] {
    --tw-gradient-to: var(--primaryColor) var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-slate-400 {
    --tw-gradient-to: #94a3b8 var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-slate-600 {
    --tw-gradient-to: #475569 var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-slate-700 {
    --tw-gradient-to: #334155 var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-slate-800 {
    --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-transparent {
    --tw-gradient-to: transparent var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-white {
    --tw-gradient-to: #fff var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .to-white\\/10 {
    --tw-gradient-to: rgb(255 255 255 / 0.1) var(--tw-gradient-to-position);
    --tw-gradient-to-position:  ;
}
  .bg-clip-text {
    background-clip: text;
}
  .object-cover {
    object-fit: cover;
}
  .p-0 {
    padding: 0px;
}
  .p-0\\.5 {
    padding: 0.125rem;
}
  .p-1 {
    padding: 0.25rem;
}
  .p-1\\.5 {
    padding: 0.375rem;
}
  .p-10 {
    padding: 2.5rem;
}
  .p-2 {
    padding: 0.5rem;
}
  .p-3 {
    padding: 0.75rem;
}
  .p-4 {
    padding: 1rem;
}
  .p-5 {
    padding: 1.25rem;
}
  .p-6 {
    padding: 1.5rem;
}
  .p-8 {
    padding: 2rem;
}
  .px-0 {
    padding-left: 0px;
    padding-right: 0px;
}
  .px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
  .px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
}
  .px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
  .px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
  .px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
  .px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
  .px-\\[18px\\] {
    padding-left: 18px;
    padding-right: 18px;
}
  .px-\\[22px\\] {
    padding-left: 22px;
    padding-right: 22px;
}
  .py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
}
  .py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}
  .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
  .py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
  .py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
}
  .py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
  .py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
}
  .py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
  .py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
  .py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
}
  .py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}
  .py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
}
  .py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px;
}
  .py-\\[18px\\] {
    padding-top: 18px;
    padding-bottom: 18px;
}
  .pb-0 {
    padding-bottom: 0px;
}
  .pb-3 {
    padding-bottom: 0.75rem;
}
  .pb-4 {
    padding-bottom: 1rem;
}
  .pe-3 {
    padding-inline-end: 0.75rem;
}
  .pl-10 {
    padding-left: 2.5rem;
}
  .pl-2 {
    padding-left: 0.5rem;
}
  .pl-3 {
    padding-left: 0.75rem;
}
  .pl-4 {
    padding-left: 1rem;
}
  .pt-0 {
    padding-top: 0px;
}
  .pt-1 {
    padding-top: 0.25rem;
}
  .pt-2 {
    padding-top: 0.5rem;
}
  .pt-3 {
    padding-top: 0.75rem;
}
  .pt-4 {
    padding-top: 1rem;
}
  .pt-5 {
    padding-top: 1.25rem;
}
  .pt-6 {
    padding-top: 1.5rem;
}
  .text-left {
    text-align: left;
}
  .text-center {
    text-align: center;
}
  .text-right {
    text-align: right;
}
  .font-\\[\\'Inter\\'\\2c sans-serif\\] {
    font-family: 'Inter',sans-serif;
}
  .font-mono {
    font-family: Roboto Mono, monospace;
}
  .font-sans {
    font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
}
  .text-2xl {
    font-size: 1.5rem;
}
  .text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}
  .text-\\[12px\\] {
    font-size: 12px;
}
  .text-\\[13px\\] {
    font-size: 13px;
}
  .text-\\[15px\\] {
    font-size: 15px;
}
  .text-\\[17px\\] {
    font-size: 17px;
}
  .text-\\[25px\\] {
    font-size: 25px;
}
  .text-\\[30px\\] {
    font-size: 30px;
}
  .text-\\[32px\\] {
    font-size: 32px;
}
  .text-base {
    font-size: 1rem;
}
  .text-lg {
    font-size: 1.125rem;
}
  .text-sm {
    font-size: 0.875rem;
}
  .text-xl {
    font-size: 1.25rem;
}
  .text-xs {
    font-size: 0.75rem;
}
  .font-bold {
    font-weight: 700;
}
  .font-medium {
    font-weight: 500;
}
  .font-normal {
    font-weight: 400;
}
  .font-semibold {
    font-weight: 600;
}
  .font-thin {
    font-weight: 100;
}
  .uppercase {
    text-transform: uppercase;
}
  .lowercase {
    text-transform: lowercase;
}
  .capitalize {
    text-transform: capitalize;
}
  .italic {
    font-style: italic;
}
  .leading-5 {
    line-height: 1.25rem;
}
  .leading-relaxed {
    line-height: 1.625;
}
  .leading-tight {
    line-height: 1.25;
}
  .tracking-\\[-0\\.5px\\] {
    letter-spacing: -0.5px;
}
  .tracking-\\[-1px\\] {
    letter-spacing: -1px;
}
  .tracking-wider {
    letter-spacing: 0.05em;
}
  .text-\\[\\#00a1f1\\] {
    --tw-text-opacity: 1;
    color: rgb(0 161 241 / var(--tw-text-opacity));
}
  .text-\\[\\#2c2419\\] {
    --tw-text-opacity: 1;
    color: rgb(44 36 25 / var(--tw-text-opacity));
}
  .text-\\[\\#5d5448\\] {
    --tw-text-opacity: 1;
    color: rgb(93 84 72 / var(--tw-text-opacity));
}
  .text-\\[\\#6B7C93\\] {
    --tw-text-opacity: 1;
    color: rgb(107 124 147 / var(--tw-text-opacity));
}
  .text-\\[\\#8b7d6b\\] {
    --tw-text-opacity: 1;
    color: rgb(139 125 107 / var(--tw-text-opacity));
}
  .text-\\[\\#db4437\\] {
    --tw-text-opacity: 1;
    color: rgb(219 68 55 / var(--tw-text-opacity));
}
  .text-\\[\\#e74c3c\\] {
    --tw-text-opacity: 1;
    color: rgb(231 76 60 / var(--tw-text-opacity));
}
  .text-\\[var\\(--primaryColor\\)\\] {
    color: var(--primaryColor);
}
  .text-amber-500 {
    --tw-text-opacity: 1;
    color: rgb(245 158 11 / var(--tw-text-opacity));
}
  .text-amber-700 {
    --tw-text-opacity: 1;
    color: rgb(180 83 9 / var(--tw-text-opacity));
}
  .text-amber-800 {
    --tw-text-opacity: 1;
    color: rgb(146 64 14 / var(--tw-text-opacity));
}
  .text-amber-900 {
    --tw-text-opacity: 1;
    color: rgb(120 53 15 / var(--tw-text-opacity));
}
  .text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}
  .text-blue-500 {
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity));
}
  .text-blue-600 {
    --tw-text-opacity: 1;
    color: rgb(37 99 235 / var(--tw-text-opacity));
}
  .text-blue-700 {
    --tw-text-opacity: 1;
    color: rgb(29 78 216 / var(--tw-text-opacity));
}
  .text-blue-800 {
    --tw-text-opacity: 1;
    color: rgb(30 64 175 / var(--tw-text-opacity));
}
  .text-blue-900 {
    --tw-text-opacity: 1;
    color: rgb(30 58 138 / var(--tw-text-opacity));
}
  .text-emerald-500 {
    --tw-text-opacity: 1;
    color: rgb(16 185 129 / var(--tw-text-opacity));
}
  .text-emerald-900 {
    --tw-text-opacity: 1;
    color: rgb(6 78 59 / var(--tw-text-opacity));
}
  .text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
}
  .text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity));
}
  .text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity));
}
  .text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity));
}
  .text-gray-800 {
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity));
}
  .text-gray-900 {
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity));
}
  .text-gray-dark {
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity));
}
  .text-green-500 {
    --tw-text-opacity: 1;
    color: rgb(34 197 94 / var(--tw-text-opacity));
}
  .text-green-600 {
    --tw-text-opacity: 1;
    color: rgb(22 163 74 / var(--tw-text-opacity));
}
  .text-green-700 {
    --tw-text-opacity: 1;
    color: rgb(21 128 61 / var(--tw-text-opacity));
}
  .text-green-800 {
    --tw-text-opacity: 1;
    color: rgb(22 101 52 / var(--tw-text-opacity));
}
  .text-indigo-500 {
    --tw-text-opacity: 1;
    color: rgb(99 102 241 / var(--tw-text-opacity));
}
  .text-indigo-600 {
    --tw-text-opacity: 1;
    color: rgb(79 70 229 / var(--tw-text-opacity));
}
  .text-orange-500 {
    --tw-text-opacity: 1;
    color: rgb(249 115 22 / var(--tw-text-opacity));
}
  .text-orange-700 {
    --tw-text-opacity: 1;
    color: rgb(194 65 12 / var(--tw-text-opacity));
}
  .text-primary {
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity));
}
  .text-purple-700 {
    --tw-text-opacity: 1;
    color: rgb(126 34 206 / var(--tw-text-opacity));
}
  .text-red-500 {
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity));
}
  .text-red-600 {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity));
}
  .text-red-700 {
    --tw-text-opacity: 1;
    color: rgb(185 28 28 / var(--tw-text-opacity));
}
  .text-red-900 {
    --tw-text-opacity: 1;
    color: rgb(127 29 29 / var(--tw-text-opacity));
}
  .text-sky-700 {
    --tw-text-opacity: 1;
    color: rgb(3 105 161 / var(--tw-text-opacity));
}
  .text-slate-500 {
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity));
}
  .text-teal-900 {
    --tw-text-opacity: 1;
    color: rgb(19 78 74 / var(--tw-text-opacity));
}
  .text-transparent {
    color: transparent;
}
  .text-violet-700 {
    --tw-text-opacity: 1;
    color: rgb(109 40 217 / var(--tw-text-opacity));
}
  .text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
}
  .text-yellow-500 {
    --tw-text-opacity: 1;
    color: rgb(234 179 8 / var(--tw-text-opacity));
}
  .text-yellow-700 {
    --tw-text-opacity: 1;
    color: rgb(161 98 7 / var(--tw-text-opacity));
}
  .text-yellow-900 {
    --tw-text-opacity: 1;
    color: rgb(113 63 18 / var(--tw-text-opacity));
}
  .underline {
    text-decoration-line: underline;
}
  .no-underline {
    text-decoration-line: none;
}
  .antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
  .opacity-10 {
    opacity: 0.1;
}
  .opacity-40 {
    opacity: 0.4;
}
  .opacity-90 {
    opacity: 0.9;
}
  .shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .shadow-inner {
    --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  .outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
  .outline {
    outline-style: solid;
}
  .ring {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
  .filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
  .backdrop-blur-md {
    --tw-backdrop-blur: blur(12px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(4px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
  .transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
  .transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
  .transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
  .duration-150 {
    transition-duration: 150ms;
}
  .duration-200 {
    transition-duration: 200ms;
}
  .duration-300 {
    transition-duration: 300ms;
}
  .ease-\\[cubic-bezier\\(0\\.175\\2c 0\\.885\\2c 0\\.32\\2c 1\\.275\\)\\] {
    transition-timing-function: cubic-bezier(0.175,0.885,0.32,1.275);
}
  .ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
  .ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
  /* Background Colors */
  .bg-charcoal {
    background-color: var(--charcoal);
  }
  .bg-gold {
    background-color: var(--gold);
  }
  .bg-cream {
    background-color: var(--cream);
  }
  .bg-light-gray {
    background-color: var(--light-gray);
  }
  .bg-medium-gray {
    background-color: var(--medium-gray);
  }
  .bg-success-green {
    background-color: var(--success-green);
  }
  .bg-alert-red {
    background-color: var(--alert-red);
  }
  /* Text Colors */
  .text-charcoal {
    color: var(--charcoal);
  }
  .text-gold {
    color: var(--gold);
  }
  .text-cream {
    color: var(--cream);
  }
  .text-light-gray {
    color: var(--light-gray);
  }
  .text-medium-gray {
    color: var(--medium-gray);
  }
  .text-success-green {
    color: var(--success-green);
  }
  .text-alert-red {
    color: var(--alert-red);
  }
  /* Border Colors */
  .border-gold {
    border-color: var(--gold);
  }
  .border-light-gray {
    border-color: var(--light-gray);
  }
  .border-medium-gray {
    border-color: var(--medium-gray);
  }
  .border-success-green {
    border-color: var(--success-green);
  }
  .border-alert-red {
    border-color: var(--alert-red);
  }
  /* Hide scrollbar visually but keep the element scrollable */
  .no-scrollbar {
    -ms-overflow-style: none; /* IE / old Edge */
    scrollbar-width: none;    /* Firefox */
  }
  .no-scrollbar::-webkit-scrollbar {
    display: none;            /* Chrome / Safari / Edge */
  } 
  

  :root{
    --primaryColor: #B8A07E;
    --secondaryColor: #F8F7F9;
    --boxShadow: #e6d3b9;
    --themeFont: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    --tw-border-opacity:1;
    --highlight-text-color:#B8A07E;
    --charcoal: #2C3E50;
    --gold: #B8A07E;
    --cream: #F8F7F9;
    --light-gray: #dfdee1;
    --medium-gray: #6B7C93;
    --white: #FFFFFF;
    --sidebar-font-color: #CEDCEC;
    --success-green: #38A169;
    --alert-red: #E74C3C;
    --bg-primary:#B8A07E !important;
    /* --darkModeBg:rgba(107, 124, 147, 0.5); */
     --darkModeBg:#2A3D4F;
  }

  /* Add this to index.css - you can place it after your :root declaration */




/*=====================Dark theme==============*/
.darkTheme header{
  border-bottom: 1px solid var(--medium-gray);
  background-color: #2B3C4E;
}
.darkTheme aside{
  background: #2c3c4f;
  background: linear-gradient(172deg,rgba(44, 60, 79, 1) 0%, rgba(29, 44, 58, 1) 65%);
  /* box-shadow: 0 0 5px var(--charcoal) inset; */
}
.dark_menuActive{
  background-color: rgba(184, 160, 126, 0.15);
  color: var(--primaryColor);
}
.darkTheme main{
  background: #1E2A38;
}
.darkTheme .border-light-gray, .darkTheme .p-inputtext, .darkTheme .p-dropdown, .darkTheme .p-checkbox .p-checkbox-input, .darkTheme .darkselect{
  border-color: var(--medium-gray);
}
.darkTheme input[type="text"]::placeholder, .darkTheme .p-inputtext::placeholder{
  color: rgba(242, 242, 242, 0.4) !important;
}
.darkTheme table th, .darkTheme  .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link, .darkTheme .p-sidebar-content{
  background-color: var(--charcoal);
  color: var(--light-gray);
}
.darkTheme .p-datatable .p-datatable-thead > tr > th, .darkTheme .p-paginator{
  border-color: #000;
}
.darkTheme .p-datatable .p-datatable-thead > tr > th, .darkTheme  .p-dropdown-header, .darkTheme .p-sidebar-custom-header{
  background-color: #253545;
}
.darkTheme .dark\\:bg-gray-600, .darkTheme .bg-white, .darkTheme .p-paginator, .darkTheme .p-inputtext, .darkTheme input, 
.darkTheme .p-dropdown, .darkTheme  .p-tabview .p-tabview-nav li .p-tabview-nav-link, .darkTheme .p-dialog-content, .darkTheme .p-column-filter-overlay{
  background-color: var(--darkModeBg);
  color: var(--light-gray);
}
.darkTheme .text-medium-gray, .darkTheme .text-gray-500, .darkTheme h1, .darkTheme .p-card-content h2,
.darkTheme .p-paginator .p-paginator-first, .darkTheme .p-paginator .p-paginator-prev, .darkTheme .p-paginator .p-paginator-next, .darkTheme .p-paginator .p-paginator-last,
.darkTheme .p-card-content *, .darkTheme .text-gray-400, .darkTheme .text-gray-800, .darkTheme .p-button-label, 
.darkTheme .p-datepicker .p-yearpicker .p-yearpicker-year, .darkTheme .p-monthpicker .p-monthpicker-month, .darkTheme .p-datepicker-title .p-link
.darkTheme .p-datepicker-decade, .darkTheme .p-dropdown-item, .darkTheme .p-dropdown-empty-message, .darkTheme label{
  color: var(--light-gray);
}
.darkTheme .p-datepicker .p-datepicker-header .p-datepicker-title .p-link, .darkTheme .p-datepicker-decade, .darkTheme .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link{
  color: var(--primaryColor);
}
.darkTheme .p-card-content .p-column-filter-menu-button:hover svg{
  color: var(--primaryColor) !important;
}
.darkTheme .p-dropdown-item:hover, .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover{
  color: var(--charcoal);
}
.darkTheme .p-card,  .darkTheme .p-datepicker-monthpicker, .darkTheme .p-dropdown-panel, .darkTheme .p-overlaypanel-content {
  background-color: var(--darkModeBg);
  border: 1px solid var(--charcoal);
  color: var(--light-gray);
}
/* Notifications "•••" menu (Mark all / Mark selected as read). The wired-up
   \`dark-overlay\` class had no styles, so the white \`.p-overlaypanel\` from the
   stock PrimeReact theme (lara-light-indigo, imported unlayered via
   DateFilter.tsx) showed through the transparent buttons. Force the whole
   overlay dark with !important to win against every competing theme sheet. */
.p-overlaypanel.dark-overlay,
.p-overlaypanel.dark-overlay .p-overlaypanel-content {
  background: var(--darkModeBg) !important;
  color: var(--light-gray) !important;
  border-color: var(--charcoal);
}
/* Tailwind's preflight is disabled (\`@tailwind base\` is commented out at the
   top of this file), so these <button>s keep the native OS button background
   (light grey / disabled grey) regardless of the dark panel. Reset it. */
.p-overlaypanel.dark-overlay .p-overlaypanel-content button {
  background: transparent !important;
  border: none;
  color: var(--light-gray) !important;
}
.p-overlaypanel.dark-overlay .p-overlaypanel-content button:disabled {
  color: var(--medium-gray) !important;
}
.p-overlaypanel.dark-overlay .p-overlaypanel-content button:not(:disabled):hover {
  background-color: var(--medium-gray) !important;
}
/* Notifications header "•••" icon button. Preflight is off, so a bare <button>
   keeps the native OS chrome (grey box). Reset it to a flush, square icon
   button that only shows a subtle tint on hover — matching the filter chips. */
.notif-menu-btn {
  appearance: none;
  -webkit-appearance: none;
  background: transparent;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  cursor: pointer;
  color: var(--charcoal);
  transition: background-color 0.15s ease, color 0.15s ease;
}
.notif-menu-btn:hover {
  background-color: rgba(107, 124, 147, 0.15);
}
.notif-menu-btn:focus-visible {
  outline: 2px solid var(--primaryColor);
  outline-offset: 2px;
}
.darkTheme .notif-menu-btn {
  color: var(--light-gray);
}
.darkTheme .notif-menu-btn:hover {
  background-color: rgba(107, 124, 147, 0.4);
}

/* Slim, theme-aware scrollbar for the notifications list. Replaces the chunky
   native Windows scrollbar (with up/down arrow buttons) seen in the panel. */
.notif-scroll {
  scrollbar-width: thin;                        /* Firefox */
  scrollbar-color: rgba(107, 124, 147, 0.5) transparent;
}
.notif-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.notif-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.notif-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(107, 124, 147, 0.4);
  border-radius: 9999px;
}
.notif-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(107, 124, 147, 0.7);
}
/* Kill the native arrow buttons that Windows draws on the scrollbar */
.notif-scroll::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
.darkTheme .p-checkbox .p-checkbox-box:not(.p-checkbox.p-highlight .p-checkbox-box){
  background: transparent;
}
.darkTheme table td, .darkTheme .view_invoice, .darkTheme table td, .darkTheme .darkselect, .darkTheme .darkBg, .darkTheme .p-tree{
  background: #2B3C4E;
  color: var(--light-gray);
}
.darkTheme .p-datatable .p-datatable-header, .darkTheme .p-dialog .p-dialog-content{
  background-color: var(--darkModeBg);
  border-color: var(--charcoal);
}
.darkTheme .p-datatable .p-sortable-column.p-highlight, .darkTheme .p-paginator .p-dropdown{
  background-color: transparent !important;
}
.darkTheme .bg-cream, .darkTheme .p-selectbutton .p-button:not(.p-button.p-highlight) , .darkTheme .p-datepicker, .darkTheme .csTab .p-tabview-nav-content, .darkTheme .p-tabview-panels,
.darkTheme .p-tabview .p-tabview-nav, .darkTheme .p-dialog-content{
  background: var(--darkModeBg);
}
.darkTheme .p-datepicker .p-yearpicker .p-yearpicker-year:hover, .darkTheme .p-monthpicker .p-monthpicker-month:hover, .darkTheme .p-datepicker-header, 
.darkTheme .p-dialog-footer, .darkTheme .p-datepicker:not(.p-datepicker-inline){
  background: var(--charcoal);
}
.darkTheme .confirmDialog, .darkTheme .p-dropdown-panel, .darkTheme .p-datepicker{
  border: 1px solid var(--medium-gray);
}
.darkTheme .p-fileupload .p-fileupload-buttonbar, .darkTheme .p-fileupload-content{
  background: var(--darkModeBg);
  border-color: var(--medium-gray);
}
/* Wizard step indicator (Create/Edit Client dialog) in dark mode */
.darkTheme .p-steps .p-steps-item .p-menuitem-link{
  background: transparent;
}
.darkTheme .p-steps .p-steps-item .p-menuitem-link .p-steps-number{
  background: var(--charcoal);
  border-color: var(--medium-gray);
  color: var(--light-gray);
}
.darkTheme .p-steps .p-steps-item .p-menuitem-link .p-steps-title{
  color: #9aa7b4;
}
.darkTheme .p-steps .p-steps-item.p-highlight .p-steps-number{
  background: var(--primaryColor);
  border-color: var(--primaryColor);
  color: #ffffff;
}
.darkTheme .p-steps .p-steps-item.p-highlight .p-steps-title{
  color: var(--light-gray);
}
.darkTheme .p-steps .p-steps-item:before{
  border-top-color: var(--medium-gray);
}
/* Calendar / datepicker day cells in dark mode */
.darkTheme .p-datepicker table td{
  background: transparent;
}
.darkTheme .p-datepicker table th > span{
  color: var(--light-gray);
}
.darkTheme .p-datepicker table td > span{
  background: transparent;
  color: var(--light-gray);
  border-color: transparent;
}
.darkTheme .p-datepicker table td.p-datepicker-other-month > span,
.darkTheme .p-datepicker table td > span.p-disabled{
  color: var(--medium-gray);
}
.darkTheme .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover{
  background: var(--charcoal);
  color: var(--light-gray);
}
.darkTheme .p-datepicker table td.p-datepicker-today > span{
  background: transparent;
  color: var(--primaryColor);
  border-color: var(--primaryColor);
}
.darkTheme .p-datepicker table td > span.p-highlight,
.darkTheme .p-datepicker table td.p-datepicker-today > span.p-highlight{
  background: var(--primaryColor);
  color: #ffffff;
  border-color: var(--primaryColor);
}
/* Dropdown panel items in dark mode (selected / hover / focus) */
.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item{
  color: var(--light-gray);
  background: transparent;
}
.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight,
.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus{
  color: #ffffff;
  background: var(--primaryColor);
}
.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus,
.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover{
  color: var(--light-gray);
  background: var(--charcoal);
}
/* Month / year picker selected + hover in dark mode */
.darkTheme .p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight,
.darkTheme .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight{
  color: #ffffff;
  background: var(--primaryColor);
}
.darkTheme .p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover,
.darkTheme .p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover{
  color: var(--light-gray);
  background: var(--charcoal);
}
/* Light utility-background rows (e.g. Client document list) in dark mode */
.darkTheme .bg-gray-50{
  background: var(--darkModeBg);
  color: var(--light-gray);
}
.darkTheme .p-card-content .text-gold{
  color: var(--gold)!important;
}
.darkTheme .p-card-content .text-alert-red{
  color: var(--alert-red) !important;
}
.darkTheme .p-card-content .text-success-green{
  color: var(--success-green) !important;
}
.darkTheme .bg-teal-200{
  background: var(--medium-gray);
}
.darkTheme .p-3.bg-gray-100{
  background: var(--medium-gray);
}
.darkTheme  .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight{
  background: var(--medium-gray) ;
}
/* Permission tree: hovered node row (Tailwind hover:bg-gray-100 repaints it
   light otherwise) + themed root border. */
.darkTheme .p-tree{
  border-color: var(--medium-gray);
}
.darkTheme .p-tree .p-tree-container .p-treenode .p-treenode-content:hover{
  background: var(--charcoal);
  color: var(--light-gray);
}
/* Create User → role cards. Their bg-gray-50 collapses to --darkModeBg (the
   dialog colour), making the cards invisible; give them a distinct surface,
   a themed selected state, and a hover that beats Tailwind's hover:bg-cream. */
.darkTheme .role-option-card{
  background: #253545;
  border-color: var(--medium-gray);
}
.darkTheme .role-option-card:hover{
  background: var(--charcoal);
}
.darkTheme .role-option-card.border-gold{
  background: var(--charcoal);
  border-color: var(--primaryColor);
}
/* MultiSelect — mirror the .p-dropdown dark styling (control, label, panel, items) */
.darkTheme .p-multiselect{
  background-color: var(--darkModeBg);
  border-color: var(--medium-gray);
}
.darkTheme .p-multiselect .p-multiselect-label,
.darkTheme .p-multiselect .p-multiselect-label.p-placeholder,
.darkTheme .p-multiselect .p-multiselect-trigger{
  color: var(--light-gray);
}
.darkTheme .p-multiselect-panel,
.darkTheme .p-multiselect-panel .p-multiselect-header{
  background-color: var(--darkModeBg);
  color: var(--light-gray);
  border-color: var(--charcoal);
}
.darkTheme .p-multiselect-panel .p-multiselect-item{
  color: var(--light-gray);
}
.darkTheme .p-multiselect-panel .p-multiselect-item:hover{
  color: var(--charcoal);
}
.darkTheme .p-multiselect-panel .p-multiselect-filter{
  background-color: var(--darkModeBg);
  color: var(--light-gray);
  border-color: var(--medium-gray);
}
/* Selected token chips inside the control (default #e5e7eb is too light) */
.darkTheme .p-multiselect .p-multiselect-token,
.darkTheme .p-multiselect.p-multiselect-chip .p-multiselect-token{
  background: var(--charcoal);
  color: var(--light-gray);
}
.darkTheme .p-multiselect .p-multiselect-token .p-multiselect-token-icon{
  color: var(--light-gray);
}

/*===================== end Dark theme==============*/


body{
 margin: 0;
}
body, html *{
  font-family: var(--themeFont) !important;
  /* letter-spacing: 1px; */
}

.themeFont{
  font-family: var(--themeFont) !important;
}

/* ===== Sidebar navigation — reference-style outline menu ===== */
/* Sidebar link text colour (light mode default state). Lives in the
   components layer so the utilities \`hover:text-charcoal\` / active
   \`text-charcoal\` still override it on hover / active items. */
/* Poppins for the sidebar nav, overriding the global --themeFont rule */
.sidebar-nav,
.sidebar-nav *{
  font-family: 'Poppins', var(--themeFont) !important;
}
/* Strip PrimeReact Menu chrome so our <a> templates control the look */
.sidebar-nav .p-menu,
.sidebar-nav .p-menu .p-menuitem,
.sidebar-nav .p-menu .p-menuitem-content,
.sidebar-nav .p-menu .p-menuitem-link{
  background: transparent !important;
  padding: 0 !important;
  border: none !important;
}
.sidebar-nav .p-menu .p-menuitem-content:hover{
  background: transparent !important;
}
/* Normalise nav label typography. Overrides the global 16px/white rule
   (cstheme.css \`.p-menuitem>a>span\`) that only hit the standard items and
   left Administration looking smaller/lighter. Keeps everything on the
   compact text-sm scale and lets the anchor's colour utilities (default
   \`sidebar-link-text\`, active/hover states) drive each item. */
.sidebar-nav .p-menu-list a span{
  font-size: 0.875rem;   /* text-sm */
  font-weight: 500;      /* medium */
  color: inherit;
}
/* Breathing room between the top-level nav options */
.sidebar-nav .p-menu-list > .p-menuitem{
  margin-bottom: 6px;
}
.sidebar-nav .p-menu-list > .p-menuitem:last-child{
  margin-bottom: 0;
}
/* Active-item pill: subtle left accent bar */
.sidebar-nav .sidebar-active{
  position: relative;
}
.sidebar-nav .sidebar-active::before{
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 60%;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--primaryColor);
}


.csLoader{
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgb(192 198 211 / 50%);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.csLoader>img,
.csLoader>svg{
  width: 20rem;
}

  /* Badge Styles */
  .p-badge.p-badge-warning {
    background-color: #F59E0B !important;
    color: #ffffff !important;
  }

  /* Status Badge Styles - Match with the style guide */
  .status-badge {
    height: 24px;
    border-radius: 12px;
    padding: 4px 8px;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .status-badge.paid {
    background-color: #047857;
    color: white;
  }

  .status-badge.pending {
    background-color: #F59E0B;
    color: white;
  }

  .status-badge.overdue {
    background-color: #B91C1C;
    color: white;
  }

  .status-badge.draft {
    background-color: #4B5563;
    color: white;
  }

  /* Table Styles - Match with the style guide */
  /* .invoice-table thead th {
    background-color: #F3F4F6;
    padding: 12px 16px;
    border: 1px solid #E5E7EB;
  }

  .invoice-table tbody td {
    padding: 12px 16px;
    border: 1px solid #E5E7EB;
  }

  .invoice-table tbody tr:nth-child(even) {
    background-color: #F9FAFB;
  }

  .invoice-table tbody tr:hover {
    background-color: #EFF6FF;
  }

  .dark-mode .invoice-table thead th {
    background-color: #374151;
    border-color: #4B5563;
    color: #F3F4F6;
  }

  .dark-mode .invoice-table tbody td {
    border-color: #4B5563;
    color: #F3F4F6;
  }

  .dark-mode .invoice-table tbody tr:nth-child(even) {
    background-color: #1F2937;
  } */





/*cs_css*/
.p-menu-list a{
  cursor: pointer;
  margin-bottom: 5px;
}
.invoiceCard .p-card-header h3{
  margin: 0;
}
.border-blue-500 {
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.p-overlaypanel:before, .p-overlaypanel:after {
    display: none;
}
.activebtn:hover{
  background-color: var(--bg-primary) !important;
}


/*===========PrimeReact override color style==========*/
.p-menu{
  background: transparent;
}
.p-sidebar-sm{
  background-color: var(--medium-gray);
}
.p-sidebar-sm .p-sidebar-close{
  border: 1px solid var(--charcoal);
  color: var(--charcoal);
}
.p-calendar .p-inputtext, .p-calendar-w-btn-right .p-datepicker-trigger {
    height: 38px;
}
.p-inputtext{
  border-color: #d1d5db;
}
.p-inputtext:not(.p-paginator .p-inputtext){
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
}
.p-inputtext:enabled:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem var(--boxShadow);
    border-color: var(--primaryColor);
}
.p-button:not(:disabled, .actionBtn):hover{
    background: var(--primaryColor);
    opacity: 0.8;
    color: #ffffff; 
    border-color: var(--primaryColor);
}
.p-fileupload-buttonbar .p-button.p-fileupload-choose, .p-fileupload-buttonbar .p-button {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 5px;
    padding: 0.5rem 1rem;
}
.p-dialog-footer .p-button.p-button-secondary:hover{
  background-color: var(--primaryColor) !important;
  color: #fff;
}
.p-calendar:not(.p-calendar-disabled).p-focus > .p-inputtext,
.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus, .p-focus,
.p-yearpicker-year.p-highlight, .p-button:focus{
  box-shadow: 0 0 0 0.2rem var(--boxShadow);
  box-shadow: none;
}
.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight, .p-column-filter-menu-button.p-column-filter-menu-button-active,
.p-datepicker table td.p-datepicker-today > span.p-highlight, .p-datepicker table td > span.p-highlight {
    color:var(--charcoal);
    background: var(--boxShadow);
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight, .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight  {
    color:var(--charcoal);
    background: var(--boxShadow);
}

.p-dropdown:hover, .p-dropdown:focus{
  border-color: var(--primaryColor);
}
.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon, .p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
    color: var(--primaryColor);
}
.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box, .custom-select-button .p-selectbutton .p-button.p-highlight,
.p-paginator .p-paginator-pages .p-paginator-page.p-highlight  {
    border-color: var(--primaryColor);
    background: var(--primaryColor);  
    color: #ffffff;
}
.p-button.p-button-info{
  border-color: var(--primaryColor);
  background: transparent;
  color: #ffffff;
}
.p-datatable .p-sortable-column.p-highlight, .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight{
  color: var(--primaryColor);
  background-color: var(--secondaryColor);
}
.p-button.p-button-secondary:not(.actionBtn ), .p-button-group.p-button-secondary > .p-button, .p-splitbutton.p-button-secondary > .p-button, .p-fileupload-choose.p-button-secondary{
    /* color: #ffffff; */
    background: transparent;
    border: 1px solid var(--primaryColor);
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight.p-focus {
    background: rgba(239, 223, 201, 0.24);
}
.fc .fc-daygrid-day.fc-day-today {
    background-color: rgba(184, 160, 126, 0.2) !important;
}
.p-tabview-nav-container{
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  overflow: hidden;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link{
  padding: 0.5rem 1rem;
}
.p-tree .p-tree-container .p-treenode:focus > .p-treenode-content{
  box-shadow: inset 0 0 0 0.15rem rgba(184, 160, 126, 0.2) !important;
}
.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler{
  height: 1rem;
}
.csTab .p-tabview-nav-content{
  padding: 0.5rem 1rem;
  background: var(--surface-0);
}
.p-dialog-header{
  background-color: var(--charcoal) !important;
  padding: 0.8rem 1.5rem;
  color: #fff;
}
.p-dialog-header .p-dialog-title{color: #fff;}
/* Logout confirmation dialog: header follows the active theme accent
   instead of the static charcoal, so it recolours with the chosen theme. */
.confirmDialog .p-dialog-header{
  background-color: var(--primaryColor) !important;
}
.confirmDialog .p-dialog-header h3,
.confirmDialog .p-dialog-header svg{
  color: #fff !important;
}
.p-dialog-footer{
  padding: 0.8rem 1.5rem;
  border-top: 1px solid #ccc
}
.p-datatable-emptymessage td{
  text-align: center;
}


/* Date Picker Calender */

.react-datepicker-wrapper{
  width:30%;
  height:90%;
  border:1px solid rgb(219, 215, 215);
}
.report_date_picker .react-datepicker-wrapper{
  width:100%;
  height:45px;
}
.report_date_picker .react-datepicker-wrapper input{
  padding: 0.5rem 0.75rem;
  box-shadow: none !important;
}
.report_date_picker button{
  width: 45px;
  min-width: 45px;
  height:45px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.date-comp-prev-btn{
  border-top-right-radius:0px;
  border-bottom-right-radius:0px;
}
.date-comp-next-btn{
  border-top-left-radius:0px;
  border-bottom-left-radius:0px;
}
.react-datepicker__input-container{
  height:100%;
}

.react-datepicker__input-container input {
  border:none;
  width: 100%;
  height:100%;
}
.react-datepicker__tab-loop{
  position: absolute;
  top:5px;
  left:0px;
}

.react-datepicker{
  min-width: 230px;
}

/* custom css bikram  */
.p-button-danger:hover{
  background-color: red !important;
  color: #fff !important;
  border-color: red !important;
}
.p-multiselect .p-multiselect-label {
    padding: 0.5rem 0.75rem;
}
.card_custonized .p-card-body{
  padding: 0;
}
.card_custonized .p-card-content{
  padding: 0;
}
.card_content_padding .p-card-content{
  padding: 0;
}
.tabPadding_0 .p-tabview-panels{
  padding: 1.25rem 10px 0px !important;
}
.full_icon_field .p-icon-field{
  width: 100%;
}
.input_number .p-inputnumber{
  width: 100%;
}
.p-datatable{
  border: 1px solid #a4a4a48f;
  border-radius: 8px;
  overflow: auto;
}
.p-fileupload-buttonbar .p-button{
  margin: 0 !important;
}
.p-fileupload-buttonbar{
  gap: 0.5rem;
  flex-wrap: wrap;
}
.p-confirm-dialog .p-dialog-content{
  padding: 1rem !important;
}
.p-confirm-dialog .p-dialog-footer {
  padding: 1rem !important;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;

}
.p-confirm-dialog .p-dialog-footer .p-button{
  border: 1px solid var(--gold) !important;
  margin: 0px;
}
.p-confirm-dialog .p-dialog-footer .p-button.p-button-danger{
  background-color: var(--gold);
}
.ql-toolbar.ql-snow{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.ql-container.ql-snow{
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.no_button:hover{
  background-color: var(--highlight-text-color) !important;
}
@media screen and (max-width: 992px) {
  .p-datatable{
    width:calc(100vw - 90px);
  }
  .p-datatable table{
    width:100vw;
  }
  .p-sidebar-header{
    padding: 10px;
  }
  .p-sidebar-content{
    padding-inline: 0px;
  }
}
.p-dialog .p-dialog-content{
  padding: 0 1.5rem 1.5rem 1.5rem;
}
.p-datatable .p-datatable-header{
  border-top: 0;
}
.p-datatable .p-paginator{
  border-bottom: 0;
}
.p-steps .p-steps-item .p-menuitem-link{
  background-color: transparent;
}
.custom_tabview .p-tabview-nav-container .p-tabview-nav .p-tabview-nav-link{
  padding: 1rem;
}
@media screen and (max-width: 768px) {
.p-steps ol{
  flex-wrap: wrap;
}
.p-steps ol li{
  margin-bottom: 1rem;
}
.p-steps ol li .p-menuitem-link{
  padding-inline: 5px;
}
.custom_tabview .p-tabview-nav{
  border: none;
  flex-wrap: wrap;
}
.custom_tabview .p-tabview-nav li{
  margin: 10px;
}
.p-fileupload-row>div{
  padding: 0;
}
.fc .fc-col-header-cell-cushion{
  font-size: 14px !important;
}
.p-tabview-nav{
  flex-wrap: wrap;
}
.p-selectbutton.p-button-group .p-button{
  border: 1px solid #d1d5db !important;
  border-radius: 6px !important;
  margin-right: 6px;
  margin-bottom: 6px;
}
.p-selectbutton.p-button-group .p-button:hover,
.p-selectbutton.p-button-group .p-button.p-highlight{
border-color: var(--primaryColor) !important;
  background-color: var(--primaryColor) !important;
  color: #fff !important;
}
} 
.p_content_top_0 .p-card-body{
  padding-top: 0px !important;
} 
.after\\:absolute::after {
    content: var(--tw-content);
    position: absolute;
} 
.after\\:bottom-\\[-2px\\]::after {
    content: var(--tw-content);
    bottom: -2px;
} 
.after\\:left-0::after {
    content: var(--tw-content);
    left: 0px;
} 
.after\\:left-1\\/2::after {
    content: var(--tw-content);
    left: 50%;
} 
.after\\:left-\\[5px\\]::after {
    content: var(--tw-content);
    left: 5px;
} 
.after\\:top-1\\/2::after {
    content: var(--tw-content);
    top: 50%;
} 
.after\\:top-\\[2px\\]::after {
    content: var(--tw-content);
    top: 2px;
} 
.after\\:h-\\[2px\\]::after {
    content: var(--tw-content);
    height: 2px;
} 
.after\\:w-0::after {
    content: var(--tw-content);
    width: 0px;
} 
.after\\:-translate-x-1\\/2::after {
    content: var(--tw-content);
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.after\\:-translate-y-1\\/2::after {
    content: var(--tw-content);
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.after\\:transform::after {
    content: var(--tw-content);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.after\\:bg-\\[var\\(--primaryColor\\)\\]::after {
    content: var(--tw-content);
    background-color: var(--primaryColor);
} 
.after\\:text-xs::after {
    content: var(--tw-content);
    font-size: 0.75rem;
} 
.after\\:font-bold::after {
    content: var(--tw-content);
    font-weight: 700;
} 
.after\\:text-white::after {
    content: var(--tw-content);
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
} 
.after\\:opacity-0::after {
    content: var(--tw-content);
    opacity: 0;
} 
.after\\:duration-300::after {
    content: var(--tw-content);
    transition-duration: 300ms;
} 
.after\\:content-\\[\\'\\'\\]::after {
    --tw-content: '';
    content: var(--tw-content);
} 
.after\\:content-\\[\\'\\2713\\'\\]::after {
    --tw-content: '✓';
    content: var(--tw-content);
} 
.last\\:border-b-0:last-child {
    border-bottom-width: 0px;
} 
.checked\\:border-\\[var\\(--primaryColor\\)\\]:checked {
    border-color: var(--primaryColor);
} 
.checked\\:bg-\\[var\\(--primaryColor\\)\\]:checked {
    background-color: var(--primaryColor);
} 
.checked\\:after\\:opacity-100:checked::after {
    content: var(--tw-content);
    opacity: 1;
} 
.hover\\:left-full:hover {
    left: 100%;
} 
.hover\\:h-\\[100px\\]:hover {
    height: 100px;
} 
.hover\\:w-\\[100px\\]:hover {
    width: 100px;
} 
.hover\\:-translate-y-\\[2px\\]:hover {
    --tw-translate-y: -2px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.hover\\:-translate-y-\\[3px\\]:hover {
    --tw-translate-y: -3px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.hover\\:translate-x-\\[5px\\]:hover {
    --tw-translate-x: 5px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.hover\\:translate-y-\\[-5px\\]:hover {
    --tw-translate-y: -5px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.hover\\:scale-105:hover {
    --tw-scale-x: 1.05;
    --tw-scale-y: 1.05;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.hover\\:scale-\\[0\\.98\\]:hover {
    --tw-scale-x: 0.98;
    --tw-scale-y: 0.98;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.hover\\:border-\\[var\\(--primaryColor\\)\\]:hover {
    border-color: var(--primaryColor);
} 
.hover\\:border-gray-400:hover {
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity));
} 
.hover\\:border-red-600:hover {
    --tw-border-opacity: 1;
    border-color: rgb(220 38 38 / var(--tw-border-opacity));
} 
.hover\\:bg-\\[\\#f5f2ec\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(245 242 236 / var(--tw-bg-opacity));
} 
.hover\\:bg-blue-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity));
} 
.hover\\:bg-blue-50:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity));
} 
.hover\\:bg-blue-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
} 
.hover\\:bg-blue-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity));
} 
.hover\\:bg-gray-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
} 
.hover\\:bg-gray-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
} 
.hover\\:bg-gray-50:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity));
} 
.hover\\:bg-green-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(22 163 74 / var(--tw-bg-opacity));
} 
.hover\\:bg-indigo-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(67 56 202 / var(--tw-bg-opacity));
} 
.hover\\:bg-primary-dark:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(30 64 175 / var(--tw-bg-opacity));
} 
.hover\\:bg-primary-light:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(147 197 253 / var(--tw-bg-opacity));
} 
.hover\\:bg-red-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(254 226 226 / var(--tw-bg-opacity));
} 
.hover\\:bg-red-500:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(239 68 68 / var(--tw-bg-opacity));
} 
.hover\\:bg-red-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity));
} 
.hover\\:bg-violet-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(221 214 254 / var(--tw-bg-opacity));
} 
.hover\\:bg-white:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
} 
.hover\\:bg-opacity-10:hover {
    --tw-bg-opacity: 0.1;
} 
.hover\\:bg-opacity-20:hover {
    --tw-bg-opacity: 0.2;
} 
.hover\\:bg-opacity-50:hover {
    --tw-bg-opacity: 0.5;
} 
.hover\\:text-\\[\\#2C3E50\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(44 62 80 / var(--tw-text-opacity));
} 
.hover\\:text-\\[\\#6B7C93\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(107 124 147 / var(--tw-text-opacity));
} 
.hover\\:text-\\[var\\(--charcoal\\)\\]:hover {
    color: var(--charcoal);
} 
.hover\\:text-\\[var\\(--primaryColor\\)\\]:hover {
    color: var(--primaryColor);
} 
.hover\\:text-blue-800:hover {
    --tw-text-opacity: 1;
    color: rgb(30 64 175 / var(--tw-text-opacity));
} 
.hover\\:text-gray-600:hover {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity));
} 
.hover\\:text-gray-700:hover {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity));
} 
.hover\\:text-gray-800:hover {
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity));
} 
.hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
} 
.hover\\:underline:hover {
    text-decoration-line: underline;
} 
.hover\\:opacity-100:hover {
    opacity: 1;
} 
.hover\\:opacity-80:hover {
    opacity: 0.8;
} 
.hover\\:opacity-90:hover {
    opacity: 0.9;
} 
.hover\\:shadow-\\[0_16px_32px_rgba\\(201\\2c 168\\2c 118\\2c 0\\.3\\)\\]:hover {
    --tw-shadow: 0 16px 32px rgba(201,168,118,0.3);
    --tw-shadow-colored: 0 16px 32px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
} 
.hover\\:shadow-lg:hover {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
} 
.hover\\:shadow-md:hover {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
} 
.hover\\:shadow-xl:hover {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
} 
.hover\\:bg-charcoal:hover {
    background-color: var(--charcoal);
  } 
.hover\\:bg-gold:hover {
    background-color: var(--gold);
  } 
.hover\\:bg-cream:hover {
    background-color: var(--cream);
  } 
.hover\\:bg-light-gray:hover {
    background-color: var(--light-gray);
  } 
.hover\\:bg-medium-gray:hover {
    background-color: var(--medium-gray);
  } 
.hover\\:text-charcoal:hover {
    color: var(--charcoal);
  } 
.hover\\:text-gold:hover {
    color: var(--gold);
  } 
.hover\\:text-light-gray:hover {
    color: var(--light-gray);
  } 
.hover\\:text-alert-red:hover {
    color: var(--alert-red);
  } 
.hover\\:border-gold:hover {
    border-color: var(--gold);
  } 
.hover\\:after\\:w-full:hover::after {
    content: var(--tw-content);
    width: 100%;
} 
.focus\\:-translate-y-\\[2px\\]:focus {
    --tw-translate-y: -2px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.focus\\:border-\\[\\#6B7C93\\]:focus {
    --tw-border-opacity: 1;
    border-color: rgb(107 124 147 / var(--tw-border-opacity));
} 
.focus\\:border-\\[var\\(--primaryColor\\)\\]:focus {
    border-color: var(--primaryColor);
} 
.focus\\:border-blue-500:focus {
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
} 
.focus\\:border-primary:focus {
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
} 
.focus\\:border-red-500:focus {
    --tw-border-opacity: 1;
    border-color: rgb(239 68 68 / var(--tw-border-opacity));
} 
.focus\\:bg-primary-light:focus {
    --tw-bg-opacity: 1;
    background-color: rgb(147 197 253 / var(--tw-bg-opacity));
} 
.focus\\:bg-opacity-10:focus {
    --tw-bg-opacity: 0.1;
} 
.focus\\:shadow-\\[0_0_0_4px_rgba\\(201\\2c 168\\2c 118\\2c 0\\.1\\)\\2c 0_8px_16px_rgba\\(169\\2c 144\\2c 128\\2c 0\\.1\\)\\]:focus {
    --tw-shadow: 0 0 0 4px rgba(201,168,118,0.1),0 8px 16px rgba(169,144,128,0.1);
    --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color), 0 8px 16px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
} 
.focus\\:shadow-\\[0_0_0_4px_var\\(--boxShadow\\)\\2c 0_8px_16px_rgba\\(169\\2c 144\\2c 128\\2c 0\\.1\\)\\]:focus {
    --tw-shadow: 0 0 0 4px var(--boxShadow),0 8px 16px rgba(169,144,128,0.1);
    --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color), 0 8px 16px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
} 
.focus\\:shadow-\\[0_0_0_4px_var\\(--boxShadow\\)\\]:focus {
    --tw-shadow: 0 0 0 4px var(--boxShadow);
    --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
} 
.focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
} 
.focus\\:ring:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
} 
.focus\\:ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
} 
.focus\\:ring-blue-200:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity));
} 
.focus\\:ring-blue-500:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
} 
.focus\\:ring-indigo-500:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
} 
.focus\\:ring-primary-light:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity));
} 
.focus\\:ring-red-200:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity));
} 
.focus\\:ring-opacity-50:focus {
    --tw-ring-opacity: 0.5;
} 
.focus\\:ring-offset-2:focus {
    --tw-ring-offset-width: 2px;
} 
.focus\\:border-gold:focus {
    border-color: var(--gold);
  } 
.disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed;
} 
.disabled\\:border-gray-300:disabled {
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
} 
.disabled\\:bg-gray-100:disabled {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
} 
.disabled\\:bg-gray-400:disabled {
    --tw-bg-opacity: 1;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity));
} 
.disabled\\:bg-red-300:disabled {
    --tw-bg-opacity: 1;
    background-color: rgb(252 165 165 / var(--tw-bg-opacity));
} 
.disabled\\:bg-transparent:disabled {
    background-color: transparent;
} 
.disabled\\:text-gray-400:disabled {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
} 
.disabled\\:text-white:disabled {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
} 
.group:hover .group-hover\\:block {
    display: block;
} 
.group:hover .group-hover\\:h-\\[200px\\] {
    height: 200px;
} 
.group:hover .group-hover\\:w-\\[200px\\] {
    width: 200px;
} 
.group:hover .group-hover\\:w-\\[4px\\] {
    width: 4px;
} 
.group:hover .group-hover\\:scale-110 {
    --tw-scale-x: 1.1;
    --tw-scale-y: 1.1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
} 
.group:hover .group-hover\\:text-\\[\\#00a1f1\\] {
    --tw-text-opacity: 1;
    color: rgb(0 161 241 / var(--tw-text-opacity));
} 
.group:hover .group-hover\\:text-\\[\\#db4437\\] {
    --tw-text-opacity: 1;
    color: rgb(219 68 55 / var(--tw-text-opacity));
} 
:is(.dark .dark\\:divide-dark-border) > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-divide-opacity));
} 
:is(.dark .dark\\:border-dark-border) {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity));
} 
:is(.dark .dark\\:border-gray-600) {
    --tw-border-opacity: 1;
    border-color: rgb(75 85 99 / var(--tw-border-opacity));
} 
:is(.dark .dark\\:border-gray-700) {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity));
} 
:is(.dark .dark\\:border-violet-500\\/40) {
    border-color: rgb(139 92 246 / 0.4);
} 
:is(.dark .dark\\:border-white\\/10) {
    border-color: rgb(255 255 255 / 0.1);
} 
:is(.dark .dark\\:bg-dark-bg) {
    --tw-bg-opacity: 1;
    background-color: rgb(17 24 39 / var(--tw-bg-opacity));
} 
:is(.dark .dark\\:bg-dark-surface) {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
} 
:is(.dark .dark\\:bg-gray-600) {
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity));
} 
:is(.dark .dark\\:bg-gray-800) {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
} 
:is(.dark .dark\\:bg-violet-500\\/20) {
    background-color: rgb(139 92 246 / 0.2);
} 
:is(.dark .dark\\:bg-white\\/5) {
    background-color: rgb(255 255 255 / 0.05);
} 
:is(.dark .dark\\:text-base) {
    font-size: 1rem;
} 
:is(.dark .dark\\:text-gray-200) {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity));
} 
:is(.dark .dark\\:text-gray-300) {
    --tw-text-opacity: 1;
    color: rgb(209 213 219 / var(--tw-text-opacity));
} 
:is(.dark .dark\\:text-gray-400) {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
} 
:is(.dark .dark\\:text-violet-300) {
    --tw-text-opacity: 1;
    color: rgb(196 181 253 / var(--tw-text-opacity));
} 
:is(.dark .dark\\:text-white) {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
} 
:is(.dark .dark\\:text-light-gray) {
    color: var(--light-gray);
  } 
:is(.dark .dark\\:hover\\:bg-violet-500\\/30:hover) {
    background-color: rgb(139 92 246 / 0.3);
} 
:is(.dark .dark\\:hover\\:bg-white:hover) {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
} 
:is(.dark .dark\\:hover\\:bg-opacity-5:hover) {
    --tw-bg-opacity: 0.05;
} 
@media (min-width: 640px) {
    .sm\\:ml-4 {
        margin-left: 1rem;
    }
    .sm\\:mt-1 {
        margin-top: 0.25rem;
    }
    .sm\\:w-\\[180px\\] {
        width: 180px;
    }
    .sm\\:w-\\[450px\\] {
        width: 450px;
    }
    .sm\\:w-auto {
        width: auto;
    }
    .sm\\:max-w-4xl {
        max-width: 56rem;
    }
    .sm\\:flex-none {
        flex: none;
    }
    .sm\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .sm\\:flex-row {
        flex-direction: row;
    }
    .sm\\:items-center {
        align-items: center;
    }
    .sm\\:gap-4 {
        gap: 1rem;
    }
    .sm\\:pl-6 {
        padding-left: 1.5rem;
    }
} 
@media (min-width: 768px) {
    .md\\:col-span-2 {
        grid-column: span 2 / span 2;
    }
    .md\\:mb-0 {
        margin-bottom: 0px;
    }
    .md\\:mb-5 {
        margin-bottom: 1.25rem;
    }
    .md\\:mb-\\[10px\\] {
        margin-bottom: 10px;
    }
    .md\\:mb-\\[50px\\] {
        margin-bottom: 50px;
    }
    .md\\:h-\\[42px\\] {
        height: 42px;
    }
    .md\\:h-\\[90px\\] {
        height: 90px;
    }
    .md\\:w-1\\/3 {
        width: 33.333333%;
    }
    .md\\:w-64 {
        width: 16rem;
    }
    .md\\:w-\\[42px\\] {
        width: 42px;
    }
    .md\\:w-\\[90px\\] {
        width: 90px;
    }
    .md\\:w-auto {
        width: auto;
    }
    .md\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\\:grid-rows-2 {
        grid-template-rows: repeat(2, minmax(0, 1fr));
    }
    .md\\:flex-row {
        flex-direction: row;
    }
    .md\\:flex-wrap {
        flex-wrap: wrap;
    }
    .md\\:rounded-3xl {
        border-radius: 1.5rem;
    }
    .md\\:border-l {
        border-left-width: 1px;
    }
    .md\\:border-t-0 {
        border-top-width: 0px;
    }
    .md\\:p-10 {
        padding: 2.5rem;
    }
    .md\\:p-\\[40px\\] {
        padding: 40px;
    }
    .md\\:py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
    .md\\:pl-6 {
        padding-left: 1.5rem;
    }
    .md\\:pt-0 {
        padding-top: 0px;
    }
    .md\\:text-4xl {
        font-size: 2.25rem;
        line-height: 2.5rem;
    }
    .md\\:text-\\[15px\\] {
        font-size: 15px;
    }
    .md\\:text-\\[32px\\] {
        font-size: 32px;
    }
} 
@media (min-width: 1024px) {
    .lg\\:col-span-3 {
        grid-column: span 3 / span 3;
    }
    .lg\\:block {
        display: block;
    }
    .lg\\:hidden {
        display: none;
    }
    .lg\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .lg\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .lg\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .lg\\:flex-row {
        flex-direction: row;
    }
    .lg\\:p-20 {
        padding: 5rem;
    }
    .lg\\:p-\\[30px\\] {
        padding: 30px;
    }
} 
@media (min-width: 1280px) {
    .xl\\:mb-5 {
        margin-bottom: 1.25rem;
    }
    .xl\\:mb-7 {
        margin-bottom: 1.75rem;
    }
    .xl\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"CAAC,+BAA+B;;EAE9B,mBAAmB;EACnB;IAAA;AAAoB;EAApB;IAAA;QAAA;IAAoB;AAAA;EAApB;IAAA;QAAA;IAAoB;AAAA;EAApB;IAAA;QAAA;IAAoB;AAAA;EAApB;IAAA;QAAA;IAAoB;AAAA;EAApB;IAAA;QAAA;IAAoB;AAAA;EAgdpB;IACE,gCAAgC;EAClC;EAjdA;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,qBAAmB;IAAnB;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA,eAAmB;IAAnB;AAAmB;EAAnB;IAAA,mBAAmB;IAAnB;AAAmB;EAAnB;IAAA,mBAAmB;IAAnB;AAAmB;EAAnB;IAAA,gBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,gBAAmB;IAAnB,gBAAmB;IAAnB;AAAmB;EAAnB;IAAA,gBAAmB;IAAnB,gBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;QAAA;IAAmB;AAAA;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,yBAAmB;YAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,oDAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;EAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;EAAnB;IAAA,wBAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,2BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,iCAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,6BAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,4DAAmB;IAAnB,8BAAmB;IAAnB,wEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,qEAAmB;IAAnB,8BAAmB;IAAnB,wEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,oEAAmB;IAAnB,8BAAmB;IAAnB,wEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,wEAAmB;IAAnB,8BAAmB;IAAnB,wEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4DAAmB;IAAnB,8BAAmB;IAAnB,wEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4DAAmB;IAAnB,8BAAmB;IAAnB,sEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4DAAmB;IAAnB,8BAAmB;IAAnB,qEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,gEAAmB;IAAnB,8BAAmB;IAAnB,kEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,yDAAmB;IAAnB,8BAAmB;IAAnB,wEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,4EAAmB;IAAnB,8BAAmB;IAAnB,wEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,6BAAmB;IAAnB,sEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,6BAAmB;IAAnB,sEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,6BAAmB;IAAnB,sEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,6BAAmB;IAAnB,oEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,6BAAmB;IAAnB,sEAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;EAAnB;IAAA,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,uEAAmB;IAAnB;AAAmB;EAAnB;IAAA,iEAAmB;IAAnB;AAAmB;EAAnB;IAAA,gEAAmB;IAAnB;AAAmB;EAAnB;IAAA,oEAAmB;IAAnB;AAAmB;EAAnB;IAAA,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,4DAAmB;IAAnB;AAAmB;EAAnB;IAAA,qDAAmB;IAAnB;AAAmB;EAAnB;IAAA,uEAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA,qBAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,qBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,qBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,kBAAmB;IAAnB;AAAmB;EAAnB;IAAA,gBAAmB;IAAnB;AAAmB;EAAnB;IAAA,qBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,qBAAmB;IAAnB;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA,mBAAmB;IAAnB;AAAmB;EAAnB;IAAA,qBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,mBAAmB;IAAnB;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA,iBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,mBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,mCAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,0EAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;EAAnB;IAAA,gDAAmB;IAAnB,6DAAmB;IAAnB;AAAmB;EAAnB;IAAA,gDAAmB;IAAnB,6DAAmB;IAAnB;AAAmB;EAAnB;IAAA,+EAAmB;IAAnB,mGAAmB;IAAnB;AAAmB;EAAnB;IAAA,6EAAmB;IAAnB,iGAAmB;IAAnB;AAAmB;EAAnB;IAAA,sBAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;EAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;EAAnB;IAAA,gFAAmB;IAAnB,oGAAmB;IAAnB;AAAmB;EAAnB;IAAA,8BAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;EAAnB;IAAA,oBAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA,8BAAmB;IAAnB;AAAmB;EAAnB;IAAA,6BAAmB;IAAnB;AAAmB;EAAnB;IAAA,wJAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA,+BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EAAnB;IAAA;AAAmB;EA2BnB,sBAAsB;EACtB;IACE,iCAAiC;EACnC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,kCAAkC;EACpC;EAEA,gBAAgB;EAChB;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EAEA,kBAAkB;EAIlB;IACE,yBAAyB;EAC3B;EAIA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,8BAA8B;EAChC;EAEA,4DAA4D;EAC5D;IACE,wBAAwB,EAAE,kBAAkB;IAC5C,qBAAqB,KAAK,YAAY;EACxC;EACA;IACE,aAAa,aAAa,2BAA2B;EACvD;;;EApGA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,gHAAgH;IAChH,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,6BAA6B;IAC7B,wBAAwB;IACxB,oBAAoB;IACpB,+BAA+B;IAC/B,2CAA2C;KAC1C,oBAAoB;EACvB;;EAEA,0EAA0E;;;;;AAqF5E,gDAAgD;AAChD;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mFAAmF;EACnF,+CAA+C;AACjD;AACA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;;;;;EAKE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;;;;6EAI6E;AAC7E;;EAEE,wCAAwC;EACxC,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;;yEAEyE;AACzE;EACE,kCAAkC;EAClC,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,+CAA+C;AACjD;AACA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yDAAyD;AAC3D;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0CAA0C;AAC5C;;AAEA;6EAC6E;AAC7E;EACE,qBAAqB,yBAAyB,YAAY;EAC1D,qDAAqD;AACvD;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;AACA;EACE,0CAA0C;AAC5C;AACA,sEAAsE;AACtE;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA,mEAAmE;AACnE;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;AACtC;AACA,iDAAiD;AACjD;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;;EAEE,+BAA+B;EAC/B,cAAc;EACd,iCAAiC;AACnC;AACA,iEAAiE;AACjE;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,+BAA+B;AACjC;AACA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA,sDAAsD;AACtD;;EAEE,cAAc;EACd,+BAA+B;AACjC;AACA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA,2EAA2E;AAC3E;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;2CAC2C;AAC3C;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;;+EAE+E;AAC/E;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA,qFAAqF;AACrF;EACE,mCAAmC;EACnC,gCAAgC;AAClC;AACA;;;EAGE,wBAAwB;AAC1B;AACA;;EAEE,mCAAmC;EACnC,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,gCAAgC;AAClC;AACA,2EAA2E;AAC3E;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA,qDAAqD;;;AAGrD;CACC,SAAS;AACV;AACA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kEAAkE;AAClE;;+DAE+D;AAM/D,wEAAwE;AACxE;;EAEE,mDAAmD;AACrD;AACA,uEAAuE;AACvE;;;;EAIE,kCAAkC;EAClC,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;AACA;;;;+DAI+D;AAC/D;EACE,mBAAmB,IAAI,YAAY;EACnC,gBAAgB,OAAO,WAAW;EAClC,cAAc;AAChB;AACA,qDAAqD;AACrD;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,+BAA+B;AACjC;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;EAEE,iBAAiB;EACjB;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA,qDAAqD;EACrD;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,8CAA8C;EAC9C;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAgCG;;;;;;AAML,SAAS;AACT;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;IACI,sBAAsB;IACtB,wDAAwD;AAC5D;AACA;IACI,aAAa;AACjB;AACA;EACE,8CAA8C;AAChD;;;AAGA,uDAAuD;AACvD;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;IACI,YAAY;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,iCAAiC;AACrC;AACA;IACI,+BAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;AACA;EACE,gDAAgD;EAChD,WAAW;AACb;AACA;;;EAGE,yCAAyC;EACzC,gBAAgB;AAClB;AACA;;IAEI,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;EACE,iCAAiC;AACnC;AACA;IACI,0BAA0B;AAC9B;AACA;;IAEI,iCAAiC;IACjC,+BAA+B;IAC/B,cAAc;AAClB;AACA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,qDAAqD;AACzD;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mEAAmE;AACrE;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,WAAW;AACb;AACA,iCAAiC,WAAW,CAAC;AAC7C;2EAC2E;AAC3E;EACE,gDAAgD;AAClD;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB;AACF;AACA;EACE,kBAAkB;AACpB;;;AAGA,yBAAyB;;AAEzB;EACE,SAAS;EACT,UAAU;EACV,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;IACI,uBAAuB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,yBAAyB;EACzB,WAAW;;AAEb;AACA;EACE,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,wDAAwD;AAC1D;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;AAEA,4CAA4C;EAC1C,gDAAgD;EAChD,sBAAsB;AACxB;AACA;AACA;EACE,2BAA2B;AAC7B;AA17BA;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,gBA07BC;IA17BD;AA07BC;AA17BD;IAAA,iBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,qBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,8CA07BC;IA17BD,uDA07BC;IA17BD;AA07BC;AA17BD;IAAA,+EA07BC;IA17BD,mGA07BC;IA17BD;AA07BC;AA17BD;IAAA,6EA07BC;IA17BD,iGA07BC;IA17BD;AA07BC;AA17BD;IAAA,gFA07BC;IA17BD,oGA07BC;IA17BD;AA07BC;AA15BC;IACE,iCAAiC;EACnC;AACA;IACE,6BAA6B;EAC/B;AACA;IACE,8BAA8B;EAChC;AACA;IACE,mCAAmC;EACrC;AACA;IACE,oCAAoC;EACtC;AASA;IACE,sBAAsB;EACxB;AACA;IACE,kBAAkB;EACpB;AAIA;IACE,wBAAwB;EAC1B;AAOA;IACE,uBAAuB;EACzB;AAMA;IACE,yBAAyB;EAC3B;AAnFF;IAAA,0BA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,6EA07BC;IA17BD,wFA07BC;IA17BD;AA07BC;AA17BD;IAAA,wEA07BC;IA17BD,wFA07BC;IA17BD;AA07BC;AA17BD;IAAA,uCA07BC;IA17BD,qDA07BC;IA17BD;AA07BC;AA17BD;IAAA,8BA07BC;IA17BD;AA07BC;AA17BD;IAAA,2GA07BC;IA17BD,yGA07BC;IA17BD;AA07BC;AA17BD;IAAA,2GA07BC;IA17BD,yGA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AAz2BC;IACE,yBAAyB;EAC3B;AAnFF;IAAA;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,iBA07BC;IA17BD,iBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA,sBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA17BD;IAAA,oBA07BC;IA17BD;AA07BC;AA13BC;IACE,wBAAwB;EAC1B;AAlEF;IAAA;AA07BC;AA17BD;IAAA,kBA07BC;IA17BD;AA07BC;AA17BD;IAAA;AA07BC;AA17BD;IAAA;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;AAAA;AA17BD;IAAA;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA,iBA07BC;QA17BD;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA,kBA07BC;QA17BD;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;AAAA;AA17BD;IAAA;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;AAAA;AA17BD;IAAA;QAAA;IA07BC;IA17BD;QAAA;IA07BC;IA17BD;QAAA;IA07BC;AAAA","sourcesContent":[" /* @import url(cstheme.css);  */\n\n  /* @tailwind base;*/\n  @tailwind components;\n  @tailwind utilities; \n  \n\n  :root{\n    --primaryColor: #B8A07E;\n    --secondaryColor: #F8F7F9;\n    --boxShadow: #e6d3b9;\n    --themeFont: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n    --tw-border-opacity:1;\n    --highlight-text-color:#B8A07E;\n    --charcoal: #2C3E50;\n    --gold: #B8A07E;\n    --cream: #F8F7F9;\n    --light-gray: #dfdee1;\n    --medium-gray: #6B7C93;\n    --white: #FFFFFF;\n    --sidebar-font-color: #CEDCEC;\n    --success-green: #38A169;\n    --alert-red: #E74C3C;\n    --bg-primary:#B8A07E !important;\n    /* --darkModeBg:rgba(107, 124, 147, 0.5); */\n     --darkModeBg:#2A3D4F;\n  }\n\n  /* Add this to index.css - you can place it after your :root declaration */\n\n@layer utilities {\n  /* Background Colors */\n  .bg-charcoal {\n    background-color: var(--charcoal);\n  }\n  .bg-gold {\n    background-color: var(--gold);\n  }\n  .bg-cream {\n    background-color: var(--cream);\n  }\n  .bg-light-gray {\n    background-color: var(--light-gray);\n  }\n  .bg-medium-gray {\n    background-color: var(--medium-gray);\n  }\n  .bg-success-green {\n    background-color: var(--success-green);\n  }\n  .bg-alert-red {\n    background-color: var(--alert-red);\n  }\n\n  /* Text Colors */\n  .text-charcoal {\n    color: var(--charcoal);\n  }\n  .text-gold {\n    color: var(--gold);\n  }\n  .text-cream {\n    color: var(--cream);\n  }\n  .text-light-gray {\n    color: var(--light-gray);\n  }\n  .text-medium-gray {\n    color: var(--medium-gray);\n  }\n  .text-success-green {\n    color: var(--success-green);\n  }\n  .text-alert-red {\n    color: var(--alert-red);\n  }\n\n  /* Border Colors */\n  .border-charcoal {\n    border-color: var(--charcoal);\n  }\n  .border-gold {\n    border-color: var(--gold);\n  }\n  .border-cream {\n    border-color: var(--cream);\n  }\n  .border-light-gray {\n    border-color: var(--light-gray);\n  }\n  .border-medium-gray {\n    border-color: var(--medium-gray);\n  }\n  .border-success-green {\n    border-color: var(--success-green);\n  }\n  .border-alert-red {\n    border-color: var(--alert-red);\n  }\n\n  /* Hide scrollbar visually but keep the element scrollable */\n  .no-scrollbar {\n    -ms-overflow-style: none; /* IE / old Edge */\n    scrollbar-width: none;    /* Firefox */\n  }\n  .no-scrollbar::-webkit-scrollbar {\n    display: none;            /* Chrome / Safari / Edge */\n  }\n}\n\n\n\n\n/*=====================Dark theme==============*/\n.darkTheme header{\n  border-bottom: 1px solid var(--medium-gray);\n  background-color: #2B3C4E;\n}\n.darkTheme aside{\n  background: #2c3c4f;\n  background: linear-gradient(172deg,rgba(44, 60, 79, 1) 0%, rgba(29, 44, 58, 1) 65%);\n  /* box-shadow: 0 0 5px var(--charcoal) inset; */\n}\n.dark_menuActive{\n  background-color: rgba(184, 160, 126, 0.15);\n  color: var(--primaryColor);\n}\n.darkTheme main{\n  background: #1E2A38;\n}\n.darkTheme .border-light-gray, .darkTheme .p-inputtext, .darkTheme .p-dropdown, .darkTheme .p-checkbox .p-checkbox-input, .darkTheme .darkselect{\n  border-color: var(--medium-gray);\n}\n.darkTheme input[type=\"text\"]::placeholder, .darkTheme .p-inputtext::placeholder{\n  color: rgba(242, 242, 242, 0.4) !important;\n}\n.darkTheme table th, .darkTheme  .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link, .darkTheme .p-sidebar-content{\n  background-color: var(--charcoal);\n  color: var(--light-gray);\n}\n.darkTheme .p-datatable .p-datatable-thead > tr > th, .darkTheme .p-paginator{\n  border-color: #000;\n}\n.darkTheme .p-datatable .p-datatable-thead > tr > th, .darkTheme  .p-dropdown-header, .darkTheme .p-sidebar-custom-header{\n  background-color: #253545;\n}\n.darkTheme .dark\\:bg-gray-600, .darkTheme .bg-white, .darkTheme .p-paginator, .darkTheme .p-inputtext, .darkTheme input, \n.darkTheme .p-dropdown, .darkTheme  .p-tabview .p-tabview-nav li .p-tabview-nav-link, .darkTheme .p-dialog-content, .darkTheme .p-column-filter-overlay{\n  background-color: var(--darkModeBg);\n  color: var(--light-gray);\n}\n.darkTheme .text-medium-gray, .darkTheme .text-gray-500, .darkTheme h1, .darkTheme .p-card-content h2,\n.darkTheme .p-paginator .p-paginator-first, .darkTheme .p-paginator .p-paginator-prev, .darkTheme .p-paginator .p-paginator-next, .darkTheme .p-paginator .p-paginator-last,\n.darkTheme .p-card-content *, .darkTheme .text-gray-400, .darkTheme .text-gray-800, .darkTheme .p-button-label, \n.darkTheme .p-datepicker .p-yearpicker .p-yearpicker-year, .darkTheme .p-monthpicker .p-monthpicker-month, .darkTheme .p-datepicker-title .p-link\n.darkTheme .p-datepicker-decade, .darkTheme .p-dropdown-item, .darkTheme .p-dropdown-empty-message, .darkTheme label{\n  color: var(--light-gray);\n}\n.darkTheme .p-datepicker .p-datepicker-header .p-datepicker-title .p-link, .darkTheme .p-datepicker-decade, .darkTheme .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link{\n  color: var(--primaryColor);\n}\n.darkTheme .p-card-content .p-column-filter-menu-button:hover svg{\n  color: var(--primaryColor) !important;\n}\n.darkTheme .p-dropdown-item:hover, .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover{\n  color: var(--charcoal);\n}\n.darkTheme .p-card,  .darkTheme .p-datepicker-monthpicker, .darkTheme .p-dropdown-panel, .darkTheme .p-overlaypanel-content {\n  background-color: var(--darkModeBg);\n  border: 1px solid var(--charcoal);\n  color: var(--light-gray);\n}\n/* Notifications \"•••\" menu (Mark all / Mark selected as read). The wired-up\n   `dark-overlay` class had no styles, so the white `.p-overlaypanel` from the\n   stock PrimeReact theme (lara-light-indigo, imported unlayered via\n   DateFilter.tsx) showed through the transparent buttons. Force the whole\n   overlay dark with !important to win against every competing theme sheet. */\n.p-overlaypanel.dark-overlay,\n.p-overlaypanel.dark-overlay .p-overlaypanel-content {\n  background: var(--darkModeBg) !important;\n  color: var(--light-gray) !important;\n  border-color: var(--charcoal);\n}\n/* Tailwind's preflight is disabled (`@tailwind base` is commented out at the\n   top of this file), so these <button>s keep the native OS button background\n   (light grey / disabled grey) regardless of the dark panel. Reset it. */\n.p-overlaypanel.dark-overlay .p-overlaypanel-content button {\n  background: transparent !important;\n  border: none;\n  color: var(--light-gray) !important;\n}\n.p-overlaypanel.dark-overlay .p-overlaypanel-content button:disabled {\n  color: var(--medium-gray) !important;\n}\n.p-overlaypanel.dark-overlay .p-overlaypanel-content button:not(:disabled):hover {\n  background-color: var(--medium-gray) !important;\n}\n/* Notifications header \"•••\" icon button. Preflight is off, so a bare <button>\n   keeps the native OS chrome (grey box). Reset it to a flush, square icon\n   button that only shows a subtle tint on hover — matching the filter chips. */\n.notif-menu-btn {\n  appearance: none;\n  -webkit-appearance: none;\n  background: transparent;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  color: var(--charcoal);\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.notif-menu-btn:hover {\n  background-color: rgba(107, 124, 147, 0.15);\n}\n.notif-menu-btn:focus-visible {\n  outline: 2px solid var(--primaryColor);\n  outline-offset: 2px;\n}\n.darkTheme .notif-menu-btn {\n  color: var(--light-gray);\n}\n.darkTheme .notif-menu-btn:hover {\n  background-color: rgba(107, 124, 147, 0.4);\n}\n\n/* Slim, theme-aware scrollbar for the notifications list. Replaces the chunky\n   native Windows scrollbar (with up/down arrow buttons) seen in the panel. */\n.notif-scroll {\n  scrollbar-width: thin;                        /* Firefox */\n  scrollbar-color: rgba(107, 124, 147, 0.5) transparent;\n}\n.notif-scroll::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.notif-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n.notif-scroll::-webkit-scrollbar-thumb {\n  background-color: rgba(107, 124, 147, 0.4);\n  border-radius: 9999px;\n}\n.notif-scroll::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(107, 124, 147, 0.7);\n}\n/* Kill the native arrow buttons that Windows draws on the scrollbar */\n.notif-scroll::-webkit-scrollbar-button {\n  display: none;\n  width: 0;\n  height: 0;\n}\n.darkTheme .p-checkbox .p-checkbox-box:not(.p-checkbox.p-highlight .p-checkbox-box){\n  background: transparent;\n}\n.darkTheme table td, .darkTheme .view_invoice, .darkTheme table td, .darkTheme .darkselect, .darkTheme .darkBg, .darkTheme .p-tree{\n  background: #2B3C4E;\n  color: var(--light-gray);\n}\n.darkTheme .p-datatable .p-datatable-header, .darkTheme .p-dialog .p-dialog-content{\n  background-color: var(--darkModeBg);\n  border-color: var(--charcoal);\n}\n.darkTheme .p-datatable .p-sortable-column.p-highlight, .darkTheme .p-paginator .p-dropdown{\n  background-color: transparent !important;\n}\n.darkTheme .bg-cream, .darkTheme .p-selectbutton .p-button:not(.p-button.p-highlight) , .darkTheme .p-datepicker, .darkTheme .csTab .p-tabview-nav-content, .darkTheme .p-tabview-panels,\n.darkTheme .p-tabview .p-tabview-nav, .darkTheme .p-dialog-content{\n  background: var(--darkModeBg);\n}\n.darkTheme .p-datepicker .p-yearpicker .p-yearpicker-year:hover, .darkTheme .p-monthpicker .p-monthpicker-month:hover, .darkTheme .p-datepicker-header, \n.darkTheme .p-dialog-footer, .darkTheme .p-datepicker:not(.p-datepicker-inline){\n  background: var(--charcoal);\n}\n.darkTheme .confirmDialog, .darkTheme .p-dropdown-panel, .darkTheme .p-datepicker{\n  border: 1px solid var(--medium-gray);\n}\n.darkTheme .p-fileupload .p-fileupload-buttonbar, .darkTheme .p-fileupload-content{\n  background: var(--darkModeBg);\n  border-color: var(--medium-gray);\n}\n/* Wizard step indicator (Create/Edit Client dialog) in dark mode */\n.darkTheme .p-steps .p-steps-item .p-menuitem-link{\n  background: transparent;\n}\n.darkTheme .p-steps .p-steps-item .p-menuitem-link .p-steps-number{\n  background: var(--charcoal);\n  border-color: var(--medium-gray);\n  color: var(--light-gray);\n}\n.darkTheme .p-steps .p-steps-item .p-menuitem-link .p-steps-title{\n  color: #9aa7b4;\n}\n.darkTheme .p-steps .p-steps-item.p-highlight .p-steps-number{\n  background: var(--primaryColor);\n  border-color: var(--primaryColor);\n  color: #ffffff;\n}\n.darkTheme .p-steps .p-steps-item.p-highlight .p-steps-title{\n  color: var(--light-gray);\n}\n.darkTheme .p-steps .p-steps-item:before{\n  border-top-color: var(--medium-gray);\n}\n/* Calendar / datepicker day cells in dark mode */\n.darkTheme .p-datepicker table td{\n  background: transparent;\n}\n.darkTheme .p-datepicker table th > span{\n  color: var(--light-gray);\n}\n.darkTheme .p-datepicker table td > span{\n  background: transparent;\n  color: var(--light-gray);\n  border-color: transparent;\n}\n.darkTheme .p-datepicker table td.p-datepicker-other-month > span,\n.darkTheme .p-datepicker table td > span.p-disabled{\n  color: var(--medium-gray);\n}\n.darkTheme .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover{\n  background: var(--charcoal);\n  color: var(--light-gray);\n}\n.darkTheme .p-datepicker table td.p-datepicker-today > span{\n  background: transparent;\n  color: var(--primaryColor);\n  border-color: var(--primaryColor);\n}\n.darkTheme .p-datepicker table td > span.p-highlight,\n.darkTheme .p-datepicker table td.p-datepicker-today > span.p-highlight{\n  background: var(--primaryColor);\n  color: #ffffff;\n  border-color: var(--primaryColor);\n}\n/* Dropdown panel items in dark mode (selected / hover / focus) */\n.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item{\n  color: var(--light-gray);\n  background: transparent;\n}\n.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight,\n.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight.p-focus{\n  color: #ffffff;\n  background: var(--primaryColor);\n}\n.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus,\n.darkTheme .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover{\n  color: var(--light-gray);\n  background: var(--charcoal);\n}\n/* Month / year picker selected + hover in dark mode */\n.darkTheme .p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight,\n.darkTheme .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight{\n  color: #ffffff;\n  background: var(--primaryColor);\n}\n.darkTheme .p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover,\n.darkTheme .p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover{\n  color: var(--light-gray);\n  background: var(--charcoal);\n}\n/* Light utility-background rows (e.g. Client document list) in dark mode */\n.darkTheme .bg-gray-50{\n  background: var(--darkModeBg);\n  color: var(--light-gray);\n}\n.darkTheme .p-card-content .text-gold{\n  color: var(--gold)!important;\n}\n.darkTheme .p-card-content .text-alert-red{\n  color: var(--alert-red) !important;\n}\n.darkTheme .p-card-content .text-success-green{\n  color: var(--success-green) !important;\n}\n.darkTheme .bg-teal-200{\n  background: var(--medium-gray);\n}\n.darkTheme .p-3.bg-gray-100{\n  background: var(--medium-gray);\n}\n.darkTheme  .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight{\n  background: var(--medium-gray) ;\n}\n/* Permission tree: hovered node row (Tailwind hover:bg-gray-100 repaints it\n   light otherwise) + themed root border. */\n.darkTheme .p-tree{\n  border-color: var(--medium-gray);\n}\n.darkTheme .p-tree .p-tree-container .p-treenode .p-treenode-content:hover{\n  background: var(--charcoal);\n  color: var(--light-gray);\n}\n/* Create User → role cards. Their bg-gray-50 collapses to --darkModeBg (the\n   dialog colour), making the cards invisible; give them a distinct surface,\n   a themed selected state, and a hover that beats Tailwind's hover:bg-cream. */\n.darkTheme .role-option-card{\n  background: #253545;\n  border-color: var(--medium-gray);\n}\n.darkTheme .role-option-card:hover{\n  background: var(--charcoal);\n}\n.darkTheme .role-option-card.border-gold{\n  background: var(--charcoal);\n  border-color: var(--primaryColor);\n}\n/* MultiSelect — mirror the .p-dropdown dark styling (control, label, panel, items) */\n.darkTheme .p-multiselect{\n  background-color: var(--darkModeBg);\n  border-color: var(--medium-gray);\n}\n.darkTheme .p-multiselect .p-multiselect-label,\n.darkTheme .p-multiselect .p-multiselect-label.p-placeholder,\n.darkTheme .p-multiselect .p-multiselect-trigger{\n  color: var(--light-gray);\n}\n.darkTheme .p-multiselect-panel,\n.darkTheme .p-multiselect-panel .p-multiselect-header{\n  background-color: var(--darkModeBg);\n  color: var(--light-gray);\n  border-color: var(--charcoal);\n}\n.darkTheme .p-multiselect-panel .p-multiselect-item{\n  color: var(--light-gray);\n}\n.darkTheme .p-multiselect-panel .p-multiselect-item:hover{\n  color: var(--charcoal);\n}\n.darkTheme .p-multiselect-panel .p-multiselect-filter{\n  background-color: var(--darkModeBg);\n  color: var(--light-gray);\n  border-color: var(--medium-gray);\n}\n/* Selected token chips inside the control (default #e5e7eb is too light) */\n.darkTheme .p-multiselect .p-multiselect-token,\n.darkTheme .p-multiselect.p-multiselect-chip .p-multiselect-token{\n  background: var(--charcoal);\n  color: var(--light-gray);\n}\n.darkTheme .p-multiselect .p-multiselect-token .p-multiselect-token-icon{\n  color: var(--light-gray);\n}\n\n/*===================== end Dark theme==============*/\n\n\nbody{\n margin: 0;\n}\nbody, html *{\n  font-family: var(--themeFont) !important;\n  /* letter-spacing: 1px; */\n}\n\n.themeFont{\n  font-family: var(--themeFont) !important;\n}\n\n/* ===== Sidebar navigation — reference-style outline menu ===== */\n/* Sidebar link text colour (light mode default state). Lives in the\n   components layer so the utilities `hover:text-charcoal` / active\n   `text-charcoal` still override it on hover / active items. */\n@layer components {\n  .sidebar-link-text {\n    color: var(--sidebar-font-color);\n  }\n}\n/* Poppins for the sidebar nav, overriding the global --themeFont rule */\n.sidebar-nav,\n.sidebar-nav *{\n  font-family: 'Poppins', var(--themeFont) !important;\n}\n/* Strip PrimeReact Menu chrome so our <a> templates control the look */\n.sidebar-nav .p-menu,\n.sidebar-nav .p-menu .p-menuitem,\n.sidebar-nav .p-menu .p-menuitem-content,\n.sidebar-nav .p-menu .p-menuitem-link{\n  background: transparent !important;\n  padding: 0 !important;\n  border: none !important;\n}\n.sidebar-nav .p-menu .p-menuitem-content:hover{\n  background: transparent !important;\n}\n/* Normalise nav label typography. Overrides the global 16px/white rule\n   (cstheme.css `.p-menuitem>a>span`) that only hit the standard items and\n   left Administration looking smaller/lighter. Keeps everything on the\n   compact text-sm scale and lets the anchor's colour utilities (default\n   `sidebar-link-text`, active/hover states) drive each item. */\n.sidebar-nav .p-menu-list a span{\n  font-size: 0.875rem;   /* text-sm */\n  font-weight: 500;      /* medium */\n  color: inherit;\n}\n/* Breathing room between the top-level nav options */\n.sidebar-nav .p-menu-list > .p-menuitem{\n  margin-bottom: 6px;\n}\n.sidebar-nav .p-menu-list > .p-menuitem:last-child{\n  margin-bottom: 0;\n}\n/* Active-item pill: subtle left accent bar */\n.sidebar-nav .sidebar-active{\n  position: relative;\n}\n.sidebar-nav .sidebar-active::before{\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 60%;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: var(--primaryColor);\n}\n\n\n.csLoader{\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background: rgb(192 198 211 / 50%);\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.csLoader>img,\n.csLoader>svg{\n  width: 20rem;\n}\n\n  /* Badge Styles */\n  .p-badge.p-badge-warning {\n    background-color: #F59E0B !important;\n    color: #ffffff !important;\n  }\n\n  /* Status Badge Styles - Match with the style guide */\n  .status-badge {\n    height: 24px;\n    border-radius: 12px;\n    padding: 4px 8px;\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n\n  .status-badge.paid {\n    background-color: #047857;\n    color: white;\n  }\n\n  .status-badge.pending {\n    background-color: #F59E0B;\n    color: white;\n  }\n\n  .status-badge.overdue {\n    background-color: #B91C1C;\n    color: white;\n  }\n\n  .status-badge.draft {\n    background-color: #4B5563;\n    color: white;\n  }\n\n  /* Table Styles - Match with the style guide */\n  /* .invoice-table thead th {\n    background-color: #F3F4F6;\n    padding: 12px 16px;\n    border: 1px solid #E5E7EB;\n  }\n\n  .invoice-table tbody td {\n    padding: 12px 16px;\n    border: 1px solid #E5E7EB;\n  }\n\n  .invoice-table tbody tr:nth-child(even) {\n    background-color: #F9FAFB;\n  }\n\n  .invoice-table tbody tr:hover {\n    background-color: #EFF6FF;\n  }\n\n  .dark-mode .invoice-table thead th {\n    background-color: #374151;\n    border-color: #4B5563;\n    color: #F3F4F6;\n  }\n\n  .dark-mode .invoice-table tbody td {\n    border-color: #4B5563;\n    color: #F3F4F6;\n  }\n\n  .dark-mode .invoice-table tbody tr:nth-child(even) {\n    background-color: #1F2937;\n  } */\n\n\n\n\n\n/*cs_css*/\n.p-menu-list a{\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n.invoiceCard .p-card-header h3{\n  margin: 0;\n}\n.border-blue-500 {\n    --tw-border-opacity: 1;\n    border-color: rgb(59 130 246 / var(--tw-border-opacity));\n}\n.p-overlaypanel:before, .p-overlaypanel:after {\n    display: none;\n}\n.activebtn:hover{\n  background-color: var(--bg-primary) !important;\n}\n\n\n/*===========PrimeReact override color style==========*/\n.p-menu{\n  background: transparent;\n}\n.p-sidebar-sm{\n  background-color: var(--medium-gray);\n}\n.p-sidebar-sm .p-sidebar-close{\n  border: 1px solid var(--charcoal);\n  color: var(--charcoal);\n}\n.p-calendar .p-inputtext, .p-calendar-w-btn-right .p-datepicker-trigger {\n    height: 38px;\n}\n.p-inputtext{\n  border-color: #d1d5db;\n}\n.p-inputtext:not(.p-paginator .p-inputtext){\n  padding: 0.5rem 0.75rem;\n  display: flex;\n  align-items: center;\n}\n.p-inputtext:enabled:focus {\n    outline: 0 none;\n    outline-offset: 0;\n    box-shadow: 0 0 0 0.2rem var(--boxShadow);\n    border-color: var(--primaryColor);\n}\n.p-button:not(:disabled, .actionBtn):hover{\n    background: var(--primaryColor);\n    opacity: 0.8;\n    color: #ffffff; \n    border-color: var(--primaryColor);\n}\n.p-fileupload-buttonbar .p-button.p-fileupload-choose, .p-fileupload-buttonbar .p-button {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 5px;\n    padding: 0.5rem 1rem;\n}\n.p-dialog-footer .p-button.p-button-secondary:hover{\n  background-color: var(--primaryColor) !important;\n  color: #fff;\n}\n.p-calendar:not(.p-calendar-disabled).p-focus > .p-inputtext,\n.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus, .p-focus,\n.p-yearpicker-year.p-highlight, .p-button:focus{\n  box-shadow: 0 0 0 0.2rem var(--boxShadow);\n  box-shadow: none;\n}\n.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight, .p-column-filter-menu-button.p-column-filter-menu-button-active,\n.p-datepicker table td.p-datepicker-today > span.p-highlight, .p-datepicker table td > span.p-highlight {\n    color:var(--charcoal);\n    background: var(--boxShadow);\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight, .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight  {\n    color:var(--charcoal);\n    background: var(--boxShadow);\n}\n\n.p-dropdown:hover, .p-dropdown:focus{\n  border-color: var(--primaryColor);\n}\n.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon, .p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {\n    color: var(--primaryColor);\n}\n.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight .p-checkbox-box, .custom-select-button .p-selectbutton .p-button.p-highlight,\n.p-paginator .p-paginator-pages .p-paginator-page.p-highlight  {\n    border-color: var(--primaryColor);\n    background: var(--primaryColor);  \n    color: #ffffff;\n}\n.p-button.p-button-info{\n  border-color: var(--primaryColor);\n  background: transparent;\n  color: #ffffff;\n}\n.p-datatable .p-sortable-column.p-highlight, .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight{\n  color: var(--primaryColor);\n  background-color: var(--secondaryColor);\n}\n.p-button.p-button-secondary:not(.actionBtn ), .p-button-group.p-button-secondary > .p-button, .p-splitbutton.p-button-secondary > .p-button, .p-fileupload-choose.p-button-secondary{\n    /* color: #ffffff; */\n    background: transparent;\n    border: 1px solid var(--primaryColor);\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight.p-focus {\n    background: rgba(239, 223, 201, 0.24);\n}\n.fc .fc-daygrid-day.fc-day-today {\n    background-color: rgba(184, 160, 126, 0.2) !important;\n}\n.p-tabview-nav-container{\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  overflow: hidden;\n}\n.p-tabview .p-tabview-nav li .p-tabview-nav-link{\n  padding: 0.5rem 1rem;\n}\n.p-tree .p-tree-container .p-treenode:focus > .p-treenode-content{\n  box-shadow: inset 0 0 0 0.15rem rgba(184, 160, 126, 0.2) !important;\n}\n.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler{\n  height: 1rem;\n}\n.csTab .p-tabview-nav-content{\n  padding: 0.5rem 1rem;\n  background: var(--surface-0);\n}\n.p-dialog-header{\n  background-color: var(--charcoal) !important;\n  padding: 0.8rem 1.5rem;\n  color: #fff;\n}\n.p-dialog-header .p-dialog-title{color: #fff;}\n/* Logout confirmation dialog: header follows the active theme accent\n   instead of the static charcoal, so it recolours with the chosen theme. */\n.confirmDialog .p-dialog-header{\n  background-color: var(--primaryColor) !important;\n}\n.confirmDialog .p-dialog-header h3,\n.confirmDialog .p-dialog-header svg{\n  color: #fff !important;\n}\n.p-dialog-footer{\n  padding: 0.8rem 1.5rem;\n  border-top: 1px solid #ccc\n}\n.p-datatable-emptymessage td{\n  text-align: center;\n}\n\n\n/* Date Picker Calender */\n\n.react-datepicker-wrapper{\n  width:30%;\n  height:90%;\n  border:1px solid rgb(219, 215, 215);\n}\n.report_date_picker .react-datepicker-wrapper{\n  width:100%;\n  height:45px;\n}\n.report_date_picker .react-datepicker-wrapper input{\n  padding: 0.5rem 0.75rem;\n  box-shadow: none !important;\n}\n.report_date_picker button{\n  width: 45px;\n  min-width: 45px;\n  height:45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n.date-comp-prev-btn{\n  border-top-right-radius:0px;\n  border-bottom-right-radius:0px;\n}\n.date-comp-next-btn{\n  border-top-left-radius:0px;\n  border-bottom-left-radius:0px;\n}\n.react-datepicker__input-container{\n  height:100%;\n}\n\n.react-datepicker__input-container input {\n  border:none;\n  width: 100%;\n  height:100%;\n}\n.react-datepicker__tab-loop{\n  position: absolute;\n  top:5px;\n  left:0px;\n}\n\n.react-datepicker{\n  min-width: 230px;\n}\n\n/* custom css bikram  */\n.p-button-danger:hover{\n  background-color: red !important;\n  color: #fff !important;\n  border-color: red !important;\n}\n.p-multiselect .p-multiselect-label {\n    padding: 0.5rem 0.75rem;\n}\n.card_custonized .p-card-body{\n  padding: 0;\n}\n.card_custonized .p-card-content{\n  padding: 0;\n}\n.card_content_padding .p-card-content{\n  padding: 0;\n}\n.tabPadding_0 .p-tabview-panels{\n  padding: 1.25rem 10px 0px !important;\n}\n.full_icon_field .p-icon-field{\n  width: 100%;\n}\n.input_number .p-inputnumber{\n  width: 100%;\n}\n.p-datatable{\n  border: 1px solid #a4a4a48f;\n  border-radius: 8px;\n  overflow: auto;\n}\n.p-fileupload-buttonbar .p-button{\n  margin: 0 !important;\n}\n.p-fileupload-buttonbar{\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n.p-confirm-dialog .p-dialog-content{\n  padding: 1rem !important;\n}\n.p-confirm-dialog .p-dialog-footer {\n  padding: 1rem !important;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n\n}\n.p-confirm-dialog .p-dialog-footer .p-button{\n  border: 1px solid var(--gold) !important;\n  margin: 0px;\n}\n.p-confirm-dialog .p-dialog-footer .p-button.p-button-danger{\n  background-color: var(--gold);\n}\n.ql-toolbar.ql-snow{\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.ql-container.ql-snow{\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.no_button:hover{\n  background-color: var(--highlight-text-color) !important;\n}\n@media screen and (max-width: 992px) {\n  .p-datatable{\n    width:calc(100vw - 90px);\n  }\n  .p-datatable table{\n    width:100vw;\n  }\n  .p-sidebar-header{\n    padding: 10px;\n  }\n  .p-sidebar-content{\n    padding-inline: 0px;\n  }\n}\n.p-dialog .p-dialog-content{\n  padding: 0 1.5rem 1.5rem 1.5rem;\n}\n.p-datatable .p-datatable-header{\n  border-top: 0;\n}\n.p-datatable .p-paginator{\n  border-bottom: 0;\n}\n.p-steps .p-steps-item .p-menuitem-link{\n  background-color: transparent;\n}\n.custom_tabview .p-tabview-nav-container .p-tabview-nav .p-tabview-nav-link{\n  padding: 1rem;\n}\n@media screen and (max-width: 768px) {\n.p-steps ol{\n  flex-wrap: wrap;\n}\n.p-steps ol li{\n  margin-bottom: 1rem;\n}\n.p-steps ol li .p-menuitem-link{\n  padding-inline: 5px;\n}\n.custom_tabview .p-tabview-nav{\n  border: none;\n  flex-wrap: wrap;\n}\n.custom_tabview .p-tabview-nav li{\n  margin: 10px;\n}\n.p-fileupload-row>div{\n  padding: 0;\n}\n.fc .fc-col-header-cell-cushion{\n  font-size: 14px !important;\n}\n.p-tabview-nav{\n  flex-wrap: wrap;\n}\n.p-selectbutton.p-button-group .p-button{\n  border: 1px solid #d1d5db !important;\n  border-radius: 6px !important;\n  margin-right: 6px;\n  margin-bottom: 6px;\n}\n.p-selectbutton.p-button-group .p-button:hover,\n.p-selectbutton.p-button-group .p-button.p-highlight{\nborder-color: var(--primaryColor) !important;\n  background-color: var(--primaryColor) !important;\n  color: #fff !important;\n}\n} \n.p_content_top_0 .p-card-body{\n  padding-top: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
